(function initPersonalizationPreviewSection() {
    const CONFIG_SELECTOR = 'script[data-personalization-config]';

    const parseConfig = (scriptEl) => {
      try {
        return JSON.parse(scriptEl.textContent || '{}');
      } catch (error) {
        console.error('[Personalization Preview] Failed to parse config JSON', error);
        return null;
      }
    };

    const initialize = (config) => {
      const sectionId = config?.sectionId;
      
      if (!sectionId) {
        console.error('Personalization config not found');
        return;
      }
      
      const section = document.getElementById('personalization-preview-' + sectionId);
      if (!section || section.dataset.previewInitialized === 'true') return;
      section.dataset.previewInitialized = 'true';
      const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
      const i18n = {
        priceLabel: isEnglish ? 'Price:' : 'Цена:',
        weightLabel: isEnglish ? 'Weight' : 'Тегло',
        heightLabel: isEnglish ? 'Height' : 'Ръст',
        timeLabel: isEnglish ? 'Time' : 'Час',
        showDescription: isEnglish ? 'Show description' : 'Покажи описанието',
        hideDescription: isEnglish ? 'Hide description' : 'Скрий описанието',
        foldedBlanket: isEnglish ? 'folded blanket' : 'сгънато одеяло'
      };

      const modelData = config.modelData || [];
      const colorData = config.colorData || [];
      const form = section.querySelector('form');
      const progressSteps = section.querySelectorAll('[data-progress-step]');
      const stepNodes = section.querySelectorAll('.preview-step');
      const previewImage = section.querySelector('[data-preview-image]');
      const previewImageInput = form?.querySelector('[data-preview-image-input]');
      const previewName = section.querySelector('[data-preview-name]');
      const previewDate = section.querySelector('[data-preview-date]');
      const previewStats = section.querySelector('[data-preview-extra]');
      const previewCanvas = section.querySelector('[data-preview-canvas]');
      const foldedPreview = section.querySelector('[data-folded-preview]');
      const foldedPreviewImage = section.querySelector('[data-folded-preview-image]');
      const foldedPreviewMeta = section.querySelector('[data-folded-preview-meta]');
      const previewExtraFields = section.querySelector('[data-preview-extra-fields]');
      const previewWeight = section.querySelector('[data-preview-weight]');
      const previewHeight = section.querySelector('[data-preview-height]');
      const previewTime = section.querySelector('[data-preview-time]');
      const timePeriodSelect = section.querySelector('[data-preview-time-period]');
      const timePeriodButtons = section.querySelectorAll('[data-time-period-option]');
      const nameInput = form?.querySelector('[data-preview-input="name"]');
      const nameFontWarning = section.querySelector('[data-name-font-warning]');
      const extraInputs = previewExtraFields ? Array.from(previewExtraFields.querySelectorAll('input, select')) : [];
      const descriptionToggles = section.querySelectorAll('[data-description-toggle]');
      const modelOptionCards = section.querySelectorAll('.preview-option--model');
      const materialInputs = form?.querySelectorAll('input[name="properties[Материя]"]') || [];
      const addToCartButton = section.querySelector('.preview-price__cta');
      const blanketInfoBlocks = Array.from(section.querySelectorAll('[data-blanket-info]'));
      const scrollToggleButton = section.querySelector('[data-scroll-toggle]');
      const scrollButtonIcon = scrollToggleButton?.querySelector('.preview-scroll-button__icon i');
      const formAnchor = section.querySelector('[data-form-anchor]');
      const heroHeader = section.querySelector('[data-preview-hero]');

      const findScrollableContainer = () => {
        let node = section.parentElement;
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node);
          const overflowY = style.overflowY || style.overflow;
          const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
          if (isScrollable && node.scrollHeight > node.clientHeight + 2) {
            return node;
          }
          node = node.parentElement;
        }
        return document.scrollingElement || document.documentElement;
      };

      const scrollHost = findScrollableContainer();
      const baseScrollElement = document.scrollingElement || document.documentElement;
      const scrollTargets = [window];
      if (scrollHost && scrollHost !== window) scrollTargets.push(scrollHost);
      if (baseScrollElement && baseScrollElement !== scrollHost) scrollTargets.push(baseScrollElement);

      // --- Focus-driven scroll: keep blanket preview near keyboard ---
      const isTextualInput = (element) => {
        if (!element || element.disabled) return false;
        if (element.tagName === 'TEXTAREA') return true;
        if (element.tagName !== 'INPUT') return false;
        const textTypes = ['text', 'email', 'tel', 'number', 'search', 'url', 'password', 'date', 'time'];
        return textTypes.includes(element.type || 'text');
      };

      let scrollTimeoutId = null;
      const scrollPageToTop = () => {
        const scrollUp = (behavior = 'smooth') => {
          scrollTargets.forEach((target) => {
            if (!target) return;
            if (target === window) {
              window.scrollTo({ top: 0, behavior });
            } else if (typeof target.scrollTo === 'function') {
              target.scrollTo({ top: 0, behavior });
            } else {
              target.scrollTop = 0;
            }
          });
        };

        scrollUp('smooth');
        setTimeout(() => scrollUp('smooth'), 250);
        setTimeout(() => scrollUp('smooth'), 600);
      };

      section.addEventListener('focusin', (event) => {
        const focused = event.target;
        if (!isTextualInput(focused)) return;
        if (window.innerWidth > 768) return;
        const insideDrawer = focused.closest('[data-model-drawer]');
        if (insideDrawer) {
          const drawerPanel = insideDrawer.querySelector('[data-drawer-content]') || insideDrawer;
          drawerPanel.scrollTop = 0;
          return;
        }
        if (scrollTimeoutId) clearTimeout(scrollTimeoutId);
        scrollTimeoutId = setTimeout(scrollPageToTop, 60);
      });

      let activeModelInput = form?.querySelector('input[name="properties[Модел]"]:checked');

    // Model Info Drawer
    const modelDrawer = section.querySelector('[data-model-drawer]');
    const drawerTitle = modelDrawer?.querySelector('[data-drawer-title]');
    const drawerPrice = modelDrawer?.querySelector('[data-drawer-price]');
    const drawerMobileMeta = modelDrawer?.querySelector('[data-drawer-mobile-meta]');
    const drawerMobileTitle = modelDrawer?.querySelector('[data-drawer-mobile-title]');
    const drawerMobilePrice = modelDrawer?.querySelector('[data-drawer-mobile-price]');
    const drawerFinalPrice = modelDrawer?.querySelector('[data-drawer-final-price]');
    const drawerFinalPriceValue = modelDrawer?.querySelector('[data-drawer-final-price-value]');
    const drawerBody = modelDrawer?.querySelector('[data-drawer-body]');
    const drawerImage = modelDrawer?.querySelector('[data-drawer-image]');
    const drawerCloseBtn = modelDrawer?.querySelector('[data-drawer-close]');
    const drawerBackdrop = modelDrawer?.querySelector('[data-drawer-backdrop]');
    const drawerContinueBtn = modelDrawer?.querySelector('[data-drawer-continue]');
    const drawerCustomization = modelDrawer?.querySelector('[data-drawer-customization]');
    const infoButtons = section.querySelectorAll('[data-model-info-btn]');
    const step1Actions = section.querySelector('[data-step-actions]');
    const step1ContinueBtn = step1Actions?.querySelector('[data-next-step]');
    
    // Mobile drawer navigation elements
    const drawerNavBack = modelDrawer?.querySelector('[data-drawer-nav-back]');
    const drawerNavForward = modelDrawer?.querySelector('[data-drawer-nav-forward]');
    const drawerStepIndicator = modelDrawer?.querySelector('[data-drawer-current-step]');
    const drawerTotalStepsEl = modelDrawer?.querySelector('[data-drawer-total-steps]');
    const drawerMaterialContainer = drawerCustomization?.querySelector('[data-drawer-material-options]');
    const drawerNameContainer = drawerCustomization?.querySelector('[data-drawer-name-field]');
    const drawerDateContainer = drawerCustomization?.querySelector('[data-drawer-date-field]');
    const drawerWeightContainer = drawerCustomization?.querySelector('[data-drawer-weight-field]');
    const drawerHeightContainer = drawerCustomization?.querySelector('[data-drawer-height-field]');
    const drawerTimeContainer = drawerCustomization?.querySelector('[data-drawer-time-field]');
    const drawerCommentContainer = drawerCustomization?.querySelector('[data-drawer-comment-field]');
    const planetStepNodes = drawerCustomization?.querySelectorAll('[data-planet-only]') || [];

    const getDrawerScrollContainers = () => {
      const containers = [];
      const panel = modelDrawer?.querySelector('.model-info-drawer__panel');
      if (panel instanceof HTMLElement) containers.push(panel);
      const drawerContentEl = modelDrawer?.querySelector('[data-drawer-content]');
      if (drawerContentEl instanceof HTMLElement) containers.push(drawerContentEl);
      if (drawerCustomization instanceof HTMLElement) containers.push(drawerCustomization);
      return containers;
    };

    const scrollDrawerToTop = (behavior = /** @type {ScrollBehavior} */ ('auto')) => {
      getDrawerScrollContainers().forEach((container) => {
        if (typeof container.scrollTo === 'function') {
          container.scrollTo({ top: 0, behavior });
        } else {
          container.scrollTop = 0;
        }
      });
    };

    const applyFieldContainerClasses = () => {
      const addClasses = (container, classes = []) => container?.classList.add(...classes);
      const BASE_CLASS = 'preview-form-grid';
      const SINGLE_CLASS = 'preview-form-grid--single';
      addClasses(drawerNameContainer, [BASE_CLASS]);
      addClasses(drawerDateContainer, [BASE_CLASS]);
      addClasses(drawerWeightContainer, [BASE_CLASS, SINGLE_CLASS]);
      addClasses(drawerHeightContainer, [BASE_CLASS, SINGLE_CLASS]);
      addClasses(drawerTimeContainer, [BASE_CLASS]);
      addClasses(drawerCommentContainer, [BASE_CLASS, 'preview-form-grid--full']);
    };
    applyFieldContainerClasses();

    const STEP_IDS = {
      NAME: 1,
      DATE: 2,
      WEIGHT: 3,
      HEIGHT: 4,
      TIME: 5,
      MATERIAL: 6,
      COMMENT: 7
    };

    const BASE_STEP_ORDER = [STEP_IDS.NAME, STEP_IDS.DATE, STEP_IDS.MATERIAL, STEP_IDS.COMMENT];
    const PLANET_STEP_ORDER = [
      STEP_IDS.NAME,
      STEP_IDS.DATE,
      STEP_IDS.WEIGHT,
      STEP_IDS.HEIGHT,
      STEP_IDS.TIME,
      STEP_IDS.MATERIAL,
      STEP_IDS.COMMENT
    ];

    let activeStepOrder = [...BASE_STEP_ORDER];
    let drawerCurrentStep = 1;
    let drawerTotalSteps = activeStepOrder.length + 1;
    let isPlanetModel = false;
    let currentModelHandle = '';
    const getCustomStepCount = () => activeStepOrder.length;
    const getLastCustomStepIndex = () => activeStepOrder.length;
    const getStepIdForIndex = (index) => activeStepOrder[index - 1];
    const getCurrentStepId = () => (typeof drawerCurrentStep === 'number' ? getStepIdForIndex(drawerCurrentStep) : null);
    const isFirstCustomizationStep = () => typeof drawerCurrentStep === 'number' && drawerCurrentStep === 1;
    const isMaterialStep = () => getCurrentStepId() === STEP_IDS.MATERIAL;
    
    // Update drawer navigation state
    const updateDrawerNavigation = () => {
      updateStepIndicator();
      
      if (drawerNavBack) {
        drawerNavBack.style.display = 'flex';
        drawerNavBack.disabled = false;
      }
      
      if (drawerNavForward) {
        if (drawerCurrentStep === 'final') {
          drawerNavForward.style.display = 'none';
        } else {
          drawerNavForward.style.display = 'flex';
        }
      }
    };

    // Layer 3: JavaScript Z-Index Enforcement
    const enforceDrawerZIndex = () => {
      if (!modelDrawer || window.innerWidth > 768) return;
      
      // CRITICAL FIX: Clear any previous suppressions first to prevent accumulation
      if (modelDrawer._competingElements) {
        restoreCompetingElements();
      }
      
      // Find all elements with high z-index that might compete
      const allElements = document.querySelectorAll('*');
      const competingElements = [];
      
      allElements.forEach(el => {
        // Skip if element is part of the drawer
        if (el.closest('[data-model-drawer]')) return;
        
        // Skip body element to prevent white overlay
        if (el.tagName === 'BODY') return;
        
        const zIndex = window.getComputedStyle(el).zIndex;
        const position = window.getComputedStyle(el).position;
        
        // Check if element has problematic z-index or position
        if ((zIndex !== 'auto' && parseInt(zIndex) > 1000) ||
            (position === 'fixed' || position === 'sticky')) {
          competingElements.push({
            element: el,
            originalZIndex: zIndex,
            originalPosition: position,
            originalVisibility: el.style.visibility,
            originalPointerEvents: el.style.pointerEvents
          });
        }
      });
      
      // Suppress competing elements
      competingElements.forEach(({ element }) => {
        element.style.setProperty('z-index', '-1', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });
      
      // Store for restoration
      modelDrawer._competingElements = competingElements;
    };
    
    const restoreCompetingElements = () => {
      if (!modelDrawer?._competingElements) return;
      
      modelDrawer._competingElements.forEach(({ element, originalZIndex, originalVisibility, originalPointerEvents }) => {
        // Remove important flags
        element.style.removeProperty('z-index');
        element.style.removeProperty('visibility');
        element.style.removeProperty('pointer-events');
        
        // Restore originals if they existed
        if (originalZIndex !== 'auto') {
          element.style.zIndex = originalZIndex;
        }
        if (originalVisibility) {
          element.style.visibility = originalVisibility;
        }
        if (originalPointerEvents) {
          element.style.pointerEvents = originalPointerEvents;
        }
      });
      
      delete modelDrawer._competingElements;
    };

    // Prevent touch scroll on background
    const preventTouchScroll = (e) => {
      if (!modelDrawer || modelDrawer.hasAttribute('hidden')) return;
      const drawerPanel = modelDrawer.querySelector('.model-info-drawer__panel');
      if (drawerPanel && !drawerPanel.contains(e.target)) {
        e.preventDefault();
      }
    };

    const openModelDrawer = (modelHandle) => {
      if (!modelDrawer || !drawerTitle || !drawerBody) return;
      
      const modelTile = section.querySelector(`[data-model-tile="${modelHandle}"]`);
      if (!modelTile) return;
      
      const modelTitle = modelTile.dataset.modelTitle;
      const modelPrice = modelTile.dataset.modelPrice;
      const descriptionHtml = modelTile.dataset.modelDescriptionHtml;
      
      if (!modelTitle || !descriptionHtml) return;
      
      drawerTitle.textContent = modelTitle;
      if (modelDrawer && modelHandle) {
        modelDrawer.dataset.currentModel = modelHandle;
      }
      if (drawerPrice) {
        if (modelPrice && modelPrice.trim().length > 0) {
          drawerPrice.textContent = modelPrice;
          drawerPrice.removeAttribute('hidden');
        } else {
          drawerPrice.textContent = '';
          drawerPrice.setAttribute('hidden', '');
        }
      }

      if (drawerFinalPrice && drawerFinalPriceValue) {
        if (modelPrice && modelPrice.trim().length > 0) {
          drawerFinalPriceValue.textContent = modelPrice;
        } else {
          drawerFinalPriceValue.textContent = '';
        }
        drawerFinalPrice.setAttribute('hidden', '');
      }

      if (drawerMobileMeta && drawerMobileTitle && drawerMobilePrice) {
        drawerMobileTitle.textContent = modelTitle || '';
        if (modelPrice && modelPrice.trim().length > 0) {
          drawerMobilePrice.textContent = modelPrice;
          drawerMobilePrice.removeAttribute('hidden');
        } else {
          drawerMobilePrice.textContent = '';
          drawerMobilePrice.setAttribute('hidden', '');
        }

        if (modelTitle || modelPrice) {
          drawerMobileMeta.removeAttribute('hidden');
        } else {
          drawerMobileMeta.setAttribute('hidden', '');
        }
      }
      drawerBody.innerHTML = descriptionHtml;
      if (drawerBody) {
        const existingPriceNote = drawerBody.querySelector('[data-drawer-price-note]');
        if (existingPriceNote) {
          existingPriceNote.remove();
        }
        if (modelPrice && modelPrice.trim().length > 0) {
          drawerBody.insertAdjacentHTML(
            'afterbegin',
            `<div class="model-info-drawer__price-note" data-drawer-price-note>
              <span>${i18n.priceLabel}</span> <strong>${modelPrice}</strong>
            </div>`
          );
        }
      }
      
      // Add model image
      if (drawerImage) {
        const modelImageElement = modelTile.querySelector('.preview-model-tile__image img');
        if (modelImageElement) {
          const imgSrc = modelImageElement.src;
          const imgAlt = modelImageElement.alt;
          drawerImage.innerHTML = `<img src="${imgSrc}" alt="${imgAlt}" loading="lazy">`;
        }
      }
      
      modelDrawer.removeAttribute('hidden');
      scrollDrawerToTop('auto');
      
      // Reset drawer navigation to step 1
      drawerCurrentStep = 1;
      updateDrawerNavigation();
      
      // Reset snap state to default (split)
      if (typeof window.resetDrawerSnapState === 'function') {
        window.resetDrawerSnapState();
      }
      
      // Prevent body scroll when drawer is open
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        // Lock body at current scroll position to prevent underlying page scroll
        const scrollY = window.scrollY;
        document.body.style.top = `-${scrollY}px`;
        document.body.dataset.scrollY = scrollY;
        
        // Layer 3: Enforce z-index suppression on mobile
        enforceDrawerZIndex();
      }
      document.body.classList.add('drawer-open');
      
      // Add touch event listener
      document.addEventListener('touchmove', preventTouchScroll, { passive: false });
    };

    const closeModelDrawer = () => {
      if (!modelDrawer) return;
      modelDrawer.setAttribute('hidden', '');
      scrollDrawerToTop('auto');

      if (drawerFinalPrice) {
        drawerFinalPrice.setAttribute('hidden', '');
      }

      // Perform complete cleanup: hide customization, clear content, reset state
      hideDrawerCustomization();

      // Always reset snap state to avoid overlay bugs
      if (typeof window.resetDrawerSnapState === 'function') {
        window.resetDrawerSnapState();
      }

      // Clean up drag state
      const handle = modelDrawer.querySelector('[data-drawer-handle]');
      if (handle) {
        handle.classList.remove('is-dragging');
      }

      // Restore body scroll
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        // Layer 3: Restore competing elements before closing
        restoreCompetingElements();
        
        const scrollY = document.body.dataset.scrollY || '0';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY, 10));
        delete document.body.dataset.scrollY;
      }
      
      // CRITICAL: Always remove drawer-open class as fail-safe
      document.body.classList.remove('drawer-open');

      // Remove touch event listener
      document.removeEventListener('touchmove', preventTouchScroll, { passive: false });
    };

    // Attach event listeners to info buttons
    infoButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const modelHandle = button.dataset.modelHandle;
        openModelDrawer(modelHandle);
      });
    });

    // Mobile: Make model tiles clickable to open drawer and select model
    const isMobileDevice = () => window.innerWidth <= 768;
    const modelTiles = section.querySelectorAll('[data-model-tile]');
    
    modelTiles.forEach((tile) => {
      tile.addEventListener('click', (event) => {
        // Only handle on mobile
        if (!isMobileDevice()) return;
        
        // Don't interfere with radio button clicks or info button clicks
        if (event.target.closest('input[type="radio"]') || event.target.closest('[data-model-info-btn]')) {
          return;
        }
        
        const modelHandle = tile.dataset.modelTile;
        const radioInput = tile.querySelector('input[type="radio"]');
        
        if (radioInput && modelHandle) {
          // Select the model
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Open the drawer and show customization
          openModelDrawer(modelHandle);
          showDrawerCustomization();
        }
      });
    });

    // Close drawer on close button click
    drawerCloseBtn?.addEventListener('click', closeModelDrawer);

    // Close drawer on backdrop click
    drawerBackdrop?.addEventListener('click', closeModelDrawer);

    // Continue button in drawer - closes drawer and proceeds to next step
    drawerContinueBtn?.addEventListener('click', () => {
      closeModelDrawer();
      if (currentStep < stepNodes.length) {
        const nextStep = currentStep + 1;
        showStep(nextStep);
        scrollToStepTop(nextStep);
      }
    });

    // Mobile drawer - draggable handle with snap-to-position behavior
    (function initDrawerDragHandler() {
      if (!modelDrawer || window.innerWidth >= 768) return;
      
      const drawerContent = modelDrawer.querySelector('[data-drawer-content]');
      const drawerHandle = modelDrawer.querySelector('[data-drawer-handle]');
      const drawerImage = modelDrawer.querySelector('[data-drawer-image]');
      
      if (!drawerContent || !drawerHandle || !drawerImage) return;
      
      const SNAP_POSITIONS = {
        'image-full': 0.85,
        'split': 0.50,
        'text-full': 0.15
      };
      
      let isDragging = false;
      let startY = 0;
      let startHeight = 0;
      
      const getClosestSnapState = (heightPercent) => {
        let closestState = 'split';
        let minDiff = Infinity;
        
        Object.entries(SNAP_POSITIONS).forEach(([state, position]) => {
          const diff = Math.abs(heightPercent - position);
          if (diff < minDiff) {
            minDiff = diff;
            closestState = state;
          }
        });
        
        return closestState;
      };
      
      const handleTouchStart = (e) => {
        if (window.innerWidth >= 768) return;
        
        // Don't initiate drag when tapping an arrow indicator
        if (e.target.closest('[data-handle-arrow]')) return;
        
        isDragging = true;
        startY = e.touches[0].clientY;
        
        const computedStyle = window.getComputedStyle(drawerImage);
        const currentFlexBasis = computedStyle.flexBasis;
        
        if (currentFlexBasis && currentFlexBasis.endsWith('%')) {
          startHeight = parseFloat(currentFlexBasis);
        } else {
          const currentSnapState = drawerContent.dataset.snapState || 'split';
          startHeight = SNAP_POSITIONS[currentSnapState] * 100;
        }
        
        drawerHandle.classList.add('is-dragging');
        drawerContent.style.setProperty('--drawer-image-height', `${startHeight}%`);
        // IMPORTANT: Don't remove data-snap-state here - keep text at current size during drag
        
        e.preventDefault();
      };
      
      const handleTouchMove = (e) => {
        if (!isDragging || window.innerWidth >= 768) return;
        
        const currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;
        const drawerHeight = drawerContent.clientHeight;
        const deltaPercent = (deltaY / drawerHeight) * 100;
        
        let newHeight = startHeight + deltaPercent;
        newHeight = Math.max(15, Math.min(85, newHeight));
        
        drawerContent.style.setProperty('--drawer-image-height', `${newHeight}%`);
        
        e.preventDefault();
      };
      
      const handleTouchEnd = (e) => {
        if (!isDragging || window.innerWidth >= 768) return;
        
        isDragging = false;
        drawerHandle.classList.remove('is-dragging');
        
        const currentHeight = parseFloat(drawerContent.style.getPropertyValue('--drawer-image-height') || '50');
        const heightPercent = currentHeight / 100;
        const snapState = getClosestSnapState(heightPercent);
        
        // Clean up inline styles and let CSS snap state rules control both height and scale
        drawerContent.style.removeProperty('--drawer-image-height');
        drawerContent.style.removeProperty('--drawer-text-scale');
        drawerContent.setAttribute('data-snap-state', snapState);
        
        e.preventDefault();
      };
      
      drawerHandle.addEventListener('touchstart', handleTouchStart, { passive: false });
      drawerHandle.addEventListener('touchmove', handleTouchMove, { passive: false });
      drawerHandle.addEventListener('touchend', handleTouchEnd, { passive: false });
      drawerHandle.addEventListener('touchcancel', handleTouchEnd, { passive: false });
    })();
    
    // Global function to reset drawer snap state
    window.resetDrawerSnapState = function() {
      const drawerContent = modelDrawer?.querySelector('[data-drawer-content]');
      if (drawerContent) {
        drawerContent.setAttribute('data-snap-state', 'split');
        drawerContent.style.removeProperty('--drawer-image-height');
      }
    };

    // Arrow tap handlers — snap back to split view
    (function initArrowTapHandlers() {
      const drawerHandle = modelDrawer?.querySelector('[data-drawer-handle]');
      if (!drawerHandle) return;

      const arrows = drawerHandle.querySelectorAll('[data-handle-arrow]');
      const drawerContent = modelDrawer?.querySelector('[data-drawer-content]');

      const snapToSplit = () => {
        if (!drawerContent) return;
        drawerContent.style.removeProperty('--drawer-image-height');
        drawerContent.style.removeProperty('--drawer-text-scale');
        drawerContent.setAttribute('data-snap-state', 'split');
      };

      arrows.forEach(arrow => {
        arrow.addEventListener('touchend', (e) => {
          e.stopPropagation();
          e.preventDefault();
          snapToSplit();
        }, { passive: false });

        arrow.addEventListener('click', (e) => {
          e.stopPropagation();
          snapToSplit();
        });
      });
    })();

    // Show Step 1 Continue button after model selection
    const showStep1ContinueButton = () => {
      if (step1ContinueBtn && currentStep === 1) {
        step1ContinueBtn.removeAttribute('hidden');
      }
    };

    // Core step management functions
    const showDrawerStep = (stepNumber) => {
      if (!modelDrawer) return;
      
      // Hide all steps
      const allSteps = modelDrawer.querySelectorAll('[data-drawer-step]');
      allSteps.forEach(step => step.setAttribute('hidden', ''));
      
      // Show target step (map step index to actual step id)
      const stepId = stepNumber === 'final' ? 'final' : getStepIdForIndex(stepNumber);
      let targetStep = modelDrawer.querySelector(`[data-drawer-step="${stepId}"]`);
      if (!targetStep && stepNumber !== 'final') {
        targetStep = modelDrawer.querySelector(`[data-drawer-step="${stepNumber}"]`);
      }
      if (targetStep) {
        targetStep.removeAttribute('hidden');
      }

      const submitBtn = modelDrawer.querySelector('[data-drawer-submit]');
      const isFinalStep = stepNumber === 'final';
      if (submitBtn) {
        if (isFinalStep) {
          submitBtn.removeAttribute('hidden');
        } else {
          submitBtn.setAttribute('hidden', '');
        }
      }
      if (drawerFinalPrice) {
        if (isFinalStep && drawerFinalPriceValue?.textContent?.trim()) {
          drawerFinalPrice.removeAttribute('hidden');
        } else {
          drawerFinalPrice.setAttribute('hidden', '');
        }
      }
      
      // Update navigation UI
      updateDrawerNavigation();
      updateNavigationButtons();
      
      // Scroll drawer content to top
      const drawerContent = modelDrawer.querySelector('[data-drawer-content]');
      if (drawerContent) {
        drawerContent.scrollTop = 0;
      }
    };
    
    const getDrawerInputValue = (target) => {
      const drawerInput = drawerCustomization?.querySelector(`[data-drawer-input][data-preview-input="${target}"]`);
      if (drawerInput) {
        return drawerInput.value.trim();
      }
      return form?.querySelector(`[data-preview-input="${target}"]`)?.value.trim() || '';
    };

    const validateCurrentStep = () => {
      if (!modelDrawer || !drawerCustomization) {
        return false;
      }

      if (drawerCurrentStep === 'final') {
        return true;
      }

      const stepId = getCurrentStepId();
      switch (stepId) {
        case STEP_IDS.MATERIAL: {
          const materialInput = drawerCustomization.querySelector('input[name="properties[Материя]"]:checked');
          return !!materialInput;
        }
        case STEP_IDS.NAME: {
          return getDrawerInputValue('name') !== '';
        }
        case STEP_IDS.DATE: {
          const dateValue = getDrawerInputValue('date');
          return dateValue !== '' && dateValue.length >= 5;
        }
        case STEP_IDS.WEIGHT:
        case STEP_IDS.HEIGHT:
        case STEP_IDS.TIME: {
          if (!isPlanetModel) return true;
          const targetMap = {
            [STEP_IDS.WEIGHT]: 'weight',
            [STEP_IDS.HEIGHT]: 'height',
            [STEP_IDS.TIME]: 'time',
          };
          const fieldName = targetMap[stepId];
          return fieldName ? getDrawerInputValue(fieldName) !== '' : true;
        }
        case STEP_IDS.COMMENT:
          return true;
        default:
          return true;
      }
    };
    
    const updateStepIndicator = () => {
      if (!drawerStepIndicator || !drawerTotalStepsEl) return;
      const displayStep = drawerCurrentStep === 'final' ? drawerTotalSteps : drawerCurrentStep;
      drawerStepIndicator.textContent = displayStep;
      drawerTotalStepsEl.textContent = drawerTotalSteps;
    };
    
    const updateNavigationButtons = () => {
      console.log('[Navigation] Updating buttons for step:', drawerCurrentStep);
      
      if (!drawerNavBack || !drawerNavForward) {
        console.log('[Navigation] Navigation buttons not found');
        return;
      }
      
      // Validate current step
      const isValid = validateCurrentStep();
      console.log('[Navigation] Current step validation result:', isValid);
      
      // Update arrow button state
      if (drawerNavForward) {
        drawerNavForward.disabled = drawerCurrentStep === 'final' ? true : !isValid;
      }
      
      // NEW: Update text buttons state
      if (drawerTextNavBack && drawerTextNavForward) {
        // Back button: Always enabled (closes drawer on step 1)
        drawerTextNavBack.disabled = false;
        drawerTextNavBack.style.visibility = 'visible';
        drawerTextNavBack.style.pointerEvents = 'auto';
        
        // Forward button: Validate based on step
        if (drawerCurrentStep === 'final') {
          drawerTextNavForward.style.display = 'none';
        } else {
          drawerTextNavForward.style.display = 'block';
          drawerTextNavForward.disabled = !isValid;
        }
        
        console.log('[Navigation] Text buttons updated - Back:', !drawerTextNavBack.disabled, 'Forward:', !drawerTextNavForward.disabled);
      }
    };
    
    const updateReviewStep = () => {
      if (!modelDrawer) return;
      
      const form = document.getElementById('personalization-preview-form-' + sectionId);
      if (!form) return;
      
      // Get model name
      const modelInput = form.querySelector('input[name="properties[Модел]"]:checked');
      const reviewModel = modelDrawer.querySelector('[data-review-model]');
      if (reviewModel && modelInput) {
        reviewModel.textContent = modelInput.value;
      }
      
      // Get material name
      const materialInput = form.querySelector('input[name="properties[Материя]"]:checked');
      const reviewMaterial = modelDrawer.querySelector('[data-review-material]');
      if (reviewMaterial && materialInput) {
        reviewMaterial.textContent = materialInput.value;
      }
      
      // Get name
      const nameInput = form.querySelector('[name="properties[Име]"]');
      const reviewName = modelDrawer.querySelector('[data-review-name]');
      if (reviewName && nameInput) {
        reviewName.textContent = nameInput.value || '-';
      }
      
      // Get date
      const dateInput = form.querySelector('[name="properties[Дата на раждане]"]');
      const reviewDate = modelDrawer.querySelector('[data-review-date]');
      if (reviewDate && dateInput) {
        reviewDate.textContent = dateInput.value || '-';
      }
      
      // Get extra fields if planet model
      const reviewExtraItem = modelDrawer.querySelector('[data-review-extra-fields]');
      const reviewExtra = modelDrawer.querySelector('[data-review-extra]');
      const reviewCommentRow = modelDrawer.querySelector('[data-review-comment-row]');
      const reviewComment = modelDrawer.querySelector('[data-review-comment]');
      
      if (isPlanetModel && reviewExtra && reviewExtraItem) {
        const weightInput = form.querySelector('[name="properties[Тегло]"]');
        const heightInput = form.querySelector('[name="properties[Ръст]"]');
        const timeInput = form.querySelector('[name="properties[Час на раждане]"]');
        const timePeriodInput = form.querySelector('[name="properties[Час (формат)]"]');
        
        const extraParts = [];
        if (weightInput?.value) extraParts.push(`${i18n.weightLabel}: ${weightInput.value}`);
        if (heightInput?.value) extraParts.push(`${i18n.heightLabel}: ${heightInput.value}`);
        if (timeInput?.value) {
          const timeValue = timeInput.value + (timePeriodInput?.value ? ` ${timePeriodInput.value}` : '');
          extraParts.push(`${i18n.timeLabel}: ${timeValue}`);
        }
        
        reviewExtra.textContent = extraParts.length > 0 ? extraParts.join(', ') : '-';
        reviewExtraItem.removeAttribute('hidden');
      } else if (reviewExtraItem) {
        reviewExtraItem.setAttribute('hidden', '');
      }

      if (reviewComment && reviewCommentRow) {
        const commentInput = form.querySelector('[name="properties[Коментар]"]');
        const value = commentInput?.value?.trim();
        if (value) {
          reviewComment.textContent = value;
          reviewCommentRow.removeAttribute('hidden');
        } else {
          reviewComment.textContent = '-';
          reviewCommentRow.setAttribute('hidden', '');
        }
      }
    };
    
    // Text Navigation Buttons (Mobile)
    const drawerTextNavBack = modelDrawer?.querySelector('[data-drawer-text-nav-back]');
    const drawerTextNavForward = modelDrawer?.querySelector('[data-drawer-text-nav-forward]');

    // Text Back Button Handler (Same logic as arrow back)
    drawerTextNavBack?.addEventListener('click', () => {
      if (isFirstCustomizationStep()) {
        // Close drawer completely on step 1
        closeModelDrawer();
      } else if (drawerCurrentStep === 'final') {
        // Go back to last customization step
        drawerCurrentStep = getLastCustomStepIndex();
        showDrawerStep(drawerCurrentStep);
        
        // Hide submit button when leaving final step
        const submitBtn = modelDrawer?.querySelector('[data-drawer-submit]');
        if (submitBtn) {
          submitBtn.setAttribute('hidden', '');
        }
        if (drawerFinalPrice) {
          drawerFinalPrice.setAttribute('hidden', '');
        }
      } else {
        // Go to previous step
        drawerCurrentStep--;
        showDrawerStep(drawerCurrentStep);
      }
    });

    // Text Forward Button Handler (Same logic as arrow forward)
    drawerTextNavForward?.addEventListener('click', () => {
      // Validate current step
      if (!validateCurrentStep()) {
        // Show validation error or just prevent navigation
        return;
      }
      
      // Determine next step
      if (typeof drawerCurrentStep === 'number' && drawerCurrentStep < getLastCustomStepIndex()) {
        // Go to next customization step
        drawerCurrentStep++;
        showDrawerStep(drawerCurrentStep);
        
        // Scroll to top of drawer content
        if (window.innerWidth <= 768) {
          const drawerBody = modelDrawer?.querySelector('[data-drawer-body]');
          const drawerCustomization = modelDrawer?.querySelector('[data-drawer-customization]');
          if (drawerBody) drawerBody.scrollTop = 0;
          if (drawerCustomization) drawerCustomization.scrollTop = 0;
        }
      } else if (drawerCurrentStep === getLastCustomStepIndex()) {
        // Go to review step
        updateReviewStep();
        drawerCurrentStep = 'final';
        showDrawerStep('final');
        
        // Show submit button on final step
        const submitBtn = modelDrawer?.querySelector('[data-drawer-submit]');
        if (submitBtn) {
          submitBtn.removeAttribute('hidden');
        }
        if (drawerFinalPrice && drawerFinalPriceValue?.textContent?.trim()) {
          drawerFinalPrice.removeAttribute('hidden');
        }
        if (drawerFinalPrice && drawerFinalPriceValue?.textContent?.trim()) {
          drawerFinalPrice.removeAttribute('hidden');
        }
        
        // Scroll to top
        if (window.innerWidth <= 768) {
          const drawerBody = modelDrawer?.querySelector('[data-drawer-body]');
          const drawerCustomization = modelDrawer?.querySelector('[data-drawer-customization]');
          if (drawerBody) drawerBody.scrollTop = 0;
          if (drawerCustomization) drawerCustomization.scrollTop = 0;
        }
      }
    });

    // Drawer navigation handlers
    drawerNavBack?.addEventListener('click', () => {
      if (isFirstCustomizationStep()) {
        // Close drawer completely on step 1
        closeModelDrawer();
      } else if (drawerCurrentStep === 'final') {
        // Go back to last customization step
        drawerCurrentStep = getLastCustomStepIndex();
        showDrawerStep(drawerCurrentStep);
        
        // Hide submit button when leaving final step
        const submitBtn = modelDrawer?.querySelector('[data-drawer-submit]');
        if (submitBtn) {
          submitBtn.setAttribute('hidden', '');
        }
        if (drawerFinalPrice) {
          drawerFinalPrice.setAttribute('hidden', '');
        }
      } else {
        // Go to previous step
        drawerCurrentStep--;
        showDrawerStep(drawerCurrentStep);
      }
    });
    
    drawerNavForward?.addEventListener('click', () => {
      // Validate current step
      if (!validateCurrentStep()) {
        // Show validation error or just prevent navigation
        return;
      }
      
      // Determine next step
      if (typeof drawerCurrentStep === 'number' && drawerCurrentStep < getLastCustomStepIndex()) {
        // Go to next customization step
        drawerCurrentStep++;
        showDrawerStep(drawerCurrentStep);
        
        // Scroll to top of page (mobile: drawer body, desktop: window)
        if (window.innerWidth <= 768) {
          // On mobile, scroll the drawer body content to top
          const drawerBody = modelDrawer?.querySelector('[data-drawer-body]');
          const drawerCustomization = modelDrawer?.querySelector('[data-drawer-customization]');
          if (drawerBody) drawerBody.scrollTop = 0;
          if (drawerCustomization) drawerCustomization.scrollTop = 0;
        } else {
          window.scrollTo(0, 0);
        }
      } else if (drawerCurrentStep === getLastCustomStepIndex()) {
        // Go to review step
        updateReviewStep();
        drawerCurrentStep = 'final';
        showDrawerStep('final');
        
        // Show submit button on final step
        const submitBtn = modelDrawer?.querySelector('[data-drawer-submit]');
        if (submitBtn) {
          submitBtn.removeAttribute('hidden');
        }
        
        // Scroll to top of page (mobile: drawer body, desktop: window)
        if (window.innerWidth <= 768) {
          // On mobile, scroll the drawer body content to top
          const drawerBody = modelDrawer?.querySelector('[data-drawer-body]');
          const drawerCustomization = modelDrawer?.querySelector('[data-drawer-customization]');
          if (drawerBody) drawerBody.scrollTop = 0;
          if (drawerCustomization) drawerCustomization.scrollTop = 0;
        } else {
          window.scrollTo(0, 0);
        }
      }
    });
    
    // Close drawer on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modelDrawer?.hasAttribute('hidden')) {
        closeModelDrawer();
      }
    });

    function updateDrawerPreviewText() {
      if (!modelDrawer) return;
      const drawer = modelDrawer;
      const drawerImageContainer = drawer.querySelector('[data-drawer-image]');
      if (!drawerImageContainer) return;
      const drawerOverlay = drawerImageContainer.querySelector('[data-drawer-preview-overlay]');
      if (!drawerOverlay) return;

      const nameEl = drawerOverlay.querySelector('[data-drawer-preview-name]');
      const dateEl = drawerOverlay.querySelector('[data-drawer-preview-date]');
      const weightEl = drawerOverlay.querySelector('[data-drawer-preview-weight]');
      const heightEl = drawerOverlay.querySelector('[data-drawer-preview-height]');
      const timeEl = drawerOverlay.querySelector('[data-drawer-preview-time]');
      const extraContainer = drawerOverlay.querySelector('[data-drawer-preview-extra]');

      if (!nameEl || !dateEl) return;

      const isMobile = window.innerWidth <= 768;
      const findInput = (target) => {
        if (isMobile) {
          const drawerInput = drawer.querySelector(`[data-drawer-input][data-preview-input="${target}"]`);
          if (drawerInput) return drawerInput;
        }
        return form?.querySelector(`[data-preview-input="${target}"]`);
      };

      const nameInputEl = findInput('name');
      const dateInputEl = findInput('date');
      const weightInputEl = findInput('weight');
      const heightInputEl = findInput('height');
      const timeInputEl = findInput('time');

      const timePeriodInputEl = isMobile
        ? (drawer.querySelector('[data-preview-time-period]') || form?.querySelector('[data-preview-time-period]'))
        : form?.querySelector('[data-preview-time-period]');

      const updateElement = (el, value, formatter = (v) => v) => {
        if (!el) return false;
        const output = (value || '').trim();
        if (output) {
          el.textContent = formatter(output);
          el.removeAttribute('hidden');
          return true;
        }
        el.setAttribute('hidden', '');
        return false;
      };

      updateElement(nameEl, nameInputEl?.value);
      updateElement(dateEl, dateInputEl?.value);

      const normalizedWeight = normalizeWeightInput(weightInputEl?.value || '', true);
      const hasWeight = updateElement(weightEl, normalizedWeight.display, (v) => v);
      const normalizedHeight = normalizeHeightInput(heightInputEl?.value || '');
      const hasHeight = updateElement(heightEl, normalizedHeight.display, (v) => v);
      const hasTime = updateElement(
        timeEl,
        timeInputEl?.value,
        (v) => {
          const suffix = timePeriodInputEl?.value;
          return suffix ? `${v} ${suffix}` : v;
        }
      );

      if (extraContainer) {
        if (hasWeight || hasHeight || hasTime) {
          extraContainer.removeAttribute('hidden');
        } else {
          extraContainer.setAttribute('hidden', '');
        }
      }
    }

    function updateDrawerPreviewFonts(modelHandle) {
      if (!modelDrawer) return;
      const drawer = modelDrawer;
      const drawerFrame = drawer.querySelector('[data-drawer-preview-frame]');
      if (!drawerFrame) return;

      if (modelHandle) {
        drawerFrame.setAttribute('data-model', modelHandle.toLowerCase());
      }

      if (previewCanvas) {
        const layoutVars = [
          '--preview-accent',
          '--layout-name-top',
          '--layout-name-translate',
          '--layout-name-letter-spacing',
          '--layout-name-scale',
          '--layout-name-weight',
          '--layout-name-word-spacing',
          '--layout-date-bottom',
          '--layout-date-right',
          '--layout-date-left',
          '--layout-date-top',
          '--layout-date-text-align',
          '--layout-date-translate',
          '--layout-date-shift-y',
          '--layout-date-font-size',
          '--layout-date-font-weight',
          '--layout-stats-bottom',
          '--layout-stats-font-size',
          '--layout-weight-left',
          '--layout-weight-bottom',
          '--layout-height-left',
          '--layout-height-bottom',
          '--layout-time-left',
          '--layout-time-bottom'
        ];

        layoutVars.forEach((varName) => {
          const value = getComputedStyle(previewCanvas).getPropertyValue(varName);
          if (value && value.trim()) {
            drawerFrame.style.setProperty(varName, value.trim());
          }
        });

        const frameWidth = drawerFrame.clientWidth;
        if (frameWidth > 0) {
          const scaledDateFont = Math.max(14, Math.min(20, frameWidth * 0.035));
          const scaledStatsFont = Math.max(14, Math.min(18, frameWidth * 0.032));
          drawerFrame.style.setProperty('--layout-date-font-size', `${scaledDateFont}px`);
          drawerFrame.style.setProperty('--layout-stats-font-size', `${scaledStatsFont}px`);
        }
      }

      const nameEl = drawer.querySelector('[data-drawer-preview-name]');
      const dateEl = drawer.querySelector('[data-drawer-preview-date]');
      const statEls = drawer.querySelectorAll('[data-drawer-preview-weight], [data-drawer-preview-height], [data-drawer-preview-time]');

      if (!nameEl) return;

      const fontConfig = MODEL_FONTS[modelHandle] || MODEL_FONTS['planet'];
      nameEl.style.fontFamily = fontConfig.name;
      nameEl.style.fontSize = `${fontConfig.size}px`;

      if (dateEl) {
        dateEl.style.fontFamily = fontConfig.numbersFont;
        dateEl.style.fontSize = `${fontConfig.numbersSize}px`;
      }

      statEls.forEach((stat) => {
        stat.style.fontFamily = fontConfig.numbersFont;
        stat.style.fontSize = `${fontConfig.numbersSize}px`;
      });
    }

    function updateDrawerPreviewImage(modelHandle, colorHandle) {
      if (!modelDrawer) return;
      const previewImg = modelDrawer.querySelector('[data-drawer-preview-image]');
      if (!previewImg) return;

      const model = findModel(modelHandle);
      if (!model) return;
      const imageUrl = model.images?.[colorHandle] || model.images?.beige;
      if (!imageUrl) return;

      const colorLabel = findColor(colorHandle)?.label || colorHandle;
      previewImg.src = imageUrl;
      previewImg.alt = `${model.title}${colorLabel ? ` - ${colorLabel}` : ''}`;
    }

    // Integrated Mobile Customization (within model drawer)
    const drawerColorGrid = drawerCustomization?.querySelector('[data-drawer-color-grid]');
    const drawerMaterialOptions = drawerCustomization?.querySelector('[data-drawer-material-options]');
    const drawerPersonalizationFields = drawerCustomization?.querySelector('[data-drawer-personalization-fields]');
    const accordionToggles = drawerCustomization?.querySelectorAll('[data-accordion-toggle]');
    
    // State for expanded accordion sections
    const expandedSections = new Set(['colors']); // Colors section open by default
    
    // Show customization section in model drawer (mobile only)
    const showDrawerCustomization = () => {
      if (!drawerCustomization || !drawerBody || window.innerWidth > 768) return;
      
      console.log('[Drawer Customization] Showing customization section');
      
      // PHASE 4: Initialize drawer preview when customization starts
      if (window.innerWidth <= 768) {
        const canvas = document.querySelector('[data-preview-canvas]');
        const currentModelHandle = canvas?.getAttribute('data-current-model');
        const currentColorHandle = canvas?.getAttribute('data-current-color');
        
        console.log('[Drawer Customization] Current model:', currentModelHandle, 'color:', currentColorHandle);
        
        // CRITICAL: Verify preview overlay elements exist before updating
        const drawerImageContainer = modelDrawer?.querySelector('[data-drawer-image]');
        const drawerPreviewOverlay = drawerImageContainer?.querySelector('[data-drawer-preview-overlay]');
        console.log('[Drawer Customization] Image container:', !!drawerImageContainer);
        console.log('[Drawer Customization] Preview overlay exists:', !!drawerPreviewOverlay);
        
        if (drawerPreviewOverlay) {
          console.log('[Drawer Customization] Preview overlay HTML:', drawerPreviewOverlay.outerHTML.substring(0, 200));
        } else {
          console.error('[Drawer Customization] Preview overlay NOT FOUND in drawer image container!');
          console.log('[Drawer Customization] Drawer image container HTML:', drawerImageContainer?.innerHTML);
        }
        
        if (currentModelHandle) {
          // Set fonts for the current model
          updateDrawerPreviewFonts(currentModelHandle);
          
          // Set the base image for current model and color
          if (currentColorHandle) {
            updateDrawerPreviewImage(currentModelHandle, currentColorHandle);
          }
          
          // Populate preview with existing form values
          updateDrawerPreviewText();
        }
      }
      
      // Determine if current model is planet
      const selectedModelInput = form?.querySelector('input[name="properties[Модел]"]:checked');
      const selectedHandle = selectedModelInput?.dataset.modelHandle || '';
      const canvas = document.querySelector('[data-preview-canvas]');
      currentModelHandle = selectedHandle || modelDrawer?.dataset.currentModel || canvas?.dataset.currentModel || '';
      if (modelDrawer && selectedHandle) {
        modelDrawer.dataset.currentModel = selectedHandle;
      }
      isPlanetModel = isPlanetModelHandle(currentModelHandle);
      
      // Update total steps (include final review step)
      drawerTotalSteps = getCustomStepCount() + 1;
      updateStepIndicator();
      activeStepOrder = isPlanetModel ? [...PLANET_STEP_ORDER] : [...BASE_STEP_ORDER];
      planetStepNodes.forEach((node) => {
        node.toggleAttribute('hidden', !isPlanetModel);
      });
      
      // Reset to step 1
      drawerCurrentStep = 1;
      drawerTotalSteps = activeStepOrder.length + 1;
      updateStepIndicator();
      
      // Hide description, show customization
      drawerBody.style.display = 'none';
      drawerCustomization.style.display = 'flex';
      scrollDrawerToTop('auto');

      // Clean up any existing content first
      cleanupDrawerContent();
      
      // Populate drawer content with fresh clones
      populateDrawerContent();
      
      // Update Latin-only warning after populating drawer
      updateLatinOnlyWarning(currentModelHandle);
      
      // Show initial step
      showDrawerStep(1);
      
      // Update preview image
      updateDrawerPreview();
    };
    
    // Cleanup drawer content - remove all cloned elements
    const cleanupDrawerContent = () => {
      if (drawerMaterialContainer) drawerMaterialContainer.innerHTML = '';
      if (drawerNameContainer) drawerNameContainer.innerHTML = '';
      if (drawerDateContainer) drawerDateContainer.innerHTML = '';
      if (drawerWeightContainer) drawerWeightContainer.innerHTML = '';
      if (drawerHeightContainer) drawerHeightContainer.innerHTML = '';
      if (drawerTimeContainer) drawerTimeContainer.innerHTML = '';
      if (drawerCommentContainer) drawerCommentContainer.innerHTML = '';
    };
    
    // Reset drawer state variables
    const resetDrawerState = () => {
      drawerCurrentStep = 1;
      isPlanetModel = false;
      currentModelHandle = '';
      activeStepOrder = [...BASE_STEP_ORDER];
      drawerTotalSteps = activeStepOrder.length + 1;
    };
    
    // Hide customization section, show description
    const hideDrawerCustomization = () => {
      if (!drawerCustomization || !drawerBody) return;
      
      // Cleanup all drawer content
      cleanupDrawerContent();
      
      // Reset state
      resetDrawerState();
      
      drawerCustomization.style.display = 'none';
      drawerBody.style.display = 'block';
    };
    
    const setupDrawerTimeButtons = (timeClone) => {
      if (!timeClone) return;
      const drawerButtons = timeClone.querySelectorAll('[data-time-period-option]');
      const drawerTimePeriodInput = timeClone.querySelector('[data-preview-time-period]');
      const syncButtonState = (value) => {
        drawerButtons.forEach((button) => {
          const buttonValue = button.dataset.timePeriodOption || '';
          button.classList.toggle('is-active', buttonValue === value);
        });
      };
      const applySelection = (value) => {
        if (drawerTimePeriodInput) {
          drawerTimePeriodInput.value = value;
        }
        syncButtonState(value);
        if (timePeriodSelect) {
          timePeriodSelect.value = value;
          timePeriodSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      drawerButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selectedValue = button.dataset.timePeriodOption || '';
          applySelection(selectedValue);
        });
      });
      const initialValue = timePeriodSelect?.value || '';
      if (drawerTimePeriodInput) {
        drawerTimePeriodInput.value = initialValue;
      }
      syncButtonState(initialValue);
    };

    const cloneInputField = (inputSelector, container, options = {}) => {
      if (!container) return;
      const sourceInput = section.querySelector(inputSelector);
      const sourceField = sourceInput?.closest('label, div');
      if (!(sourceField instanceof HTMLElement)) return;
      const clone = sourceField.cloneNode(true);
      if (!(clone instanceof HTMLElement)) return;
      const field = clone.querySelector('input, textarea');
      if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) {
        field.setAttribute('data-drawer-input', 'true');
        field.addEventListener('input', (event) => {
          handleDrawerPersonalizationInput(event);
          updateNavigationButtons();
        });
      }
      container.appendChild(clone);
      if (options.appendWarning) {
        const sourceWarning = section.querySelector('[data-name-font-warning]');
        if (sourceWarning) {
          const warningClone = sourceWarning.cloneNode(true);
          if (warningClone instanceof HTMLElement) {
            warningClone.setAttribute('data-drawer-warning', 'true');
            container.appendChild(warningClone);
          }
        }
      }
    };

    const cloneMaterialOptions = () => {
      if (!drawerMaterialContainer) return;
      const sourceMaterialOptions = section.querySelector('[data-step="2"] .preview-options--inline');
      if (!sourceMaterialOptions) return;
      const materialLabels = sourceMaterialOptions.querySelectorAll('.preview-option--material');
      materialLabels.forEach(label => {
        const clonedLabel = label.cloneNode(true);
        if (!(clonedLabel instanceof HTMLElement)) return;
        const input = clonedLabel.querySelector('input[type="radio"]');
        if (input) {
          input.setAttribute('data-drawer-input', 'true');
          input.addEventListener('change', () => {
            handleDrawerMaterialChange({ target: input });
            updateNavigationButtons();
          });
        }
        const toggle = clonedLabel.querySelector('[data-description-toggle]');
        const description = clonedLabel.querySelector('[data-description-content]');
        if (toggle instanceof HTMLElement && description instanceof HTMLElement) {
          const newToggle = toggle.cloneNode(true);
          if (newToggle instanceof HTMLElement) {
            newToggle.classList.remove('is-open');
            newToggle.setAttribute('aria-expanded', 'false');
            const labelSpan = newToggle.querySelector('[data-toggle-open]');
            if (labelSpan) {
              labelSpan.textContent = i18n.showDescription;
            }
            const iconSpan = newToggle.querySelector('.toggle-icon');
            if (iconSpan) {
              iconSpan.classList.remove('fa-angle-up');
              iconSpan.classList.add('fa-angle-down');
            }
            description.setAttribute('hidden', '');
            newToggle.addEventListener('click', (event) => {
              event.preventDefault();
              const isHidden = description.hasAttribute('hidden');
              if (isHidden) {
                description.removeAttribute('hidden');
                newToggle.classList.add('is-open');
                newToggle.setAttribute('aria-expanded', 'true');
              } else {
                description.setAttribute('hidden', '');
                newToggle.classList.remove('is-open');
                newToggle.setAttribute('aria-expanded', 'false');
              }
            });
            toggle.replaceWith(newToggle);
          }
        }
        drawerMaterialContainer.appendChild(clonedLabel);
      });
    };

    const populateDrawerContent = () => {
      cloneMaterialOptions();
      cloneInputField('[data-preview-input="name"]', drawerNameContainer, { appendWarning: true });
      cloneInputField('[data-preview-input="date"]', drawerDateContainer);

      if (isPlanetModel) {
        cloneInputField('[data-preview-input="weight"]', drawerWeightContainer);
        cloneInputField('[data-preview-input="height"]', drawerHeightContainer);
        if (drawerTimeContainer) {
          const sourceTime = section.querySelector('[data-preview-extra-fields] .preview-form-grid--time');
          if (sourceTime) {
            const timeClone = sourceTime.cloneNode(true);
            const timeInputs = timeClone.querySelectorAll('input[type="text"]');
            timeInputs.forEach((input) => {
              input.setAttribute('data-drawer-input', 'true');
              input.addEventListener('input', (event) => {
                handleDrawerPersonalizationInput(event);
                updateNavigationButtons();
              });
            });
            drawerTimeContainer.appendChild(timeClone);
            setupDrawerTimeButtons(timeClone);
          }
        }
      }

      if (drawerMaterialContainer) {
        const inputs = drawerMaterialContainer.querySelectorAll('input[type="radio"][data-drawer-input]');
        inputs.forEach((input) => {
          input.addEventListener('change', () => updateNavigationButtons());
        });
      }

      if (drawerCommentContainer) {
        cloneInputField('[data-preview-input="comment"]', drawerCommentContainer);
      }
      
      // Add auto-suffix handlers for weight and height inputs (both desktop and drawer)
      try {
        attachWeightBlurHandlers();
        setupWeightInputDelegates();
        attachHeightBlurHandlers();
        setupHeightInputDelegates();
        
        // Auto-format time input with colon (HH:MM)
        const timeInputs = section.querySelectorAll('[data-preview-input="time"]');
        timeInputs.forEach(input => {
          input.addEventListener('input', function(e) {
            try {
              const oldValue = this.value;
              const oldCursorPos = this.selectionStart;
              
              // Get only digits
              let digits = oldValue.replace(/[^\d]/g, '');
              
              // Limit to 4 digits max (HHMM)
              if (digits.length > 4) {
                digits = digits.slice(0, 4);
              }
              
              // Format with colon
              let newValue = digits;
              if (digits.length >= 3) {
                // Insert colon after 2nd digit: "0745" -> "07:45"
                newValue = digits.slice(0, 2) + ':' + digits.slice(2);
              }
              
              // Only update if value actually changed
              if (oldValue !== newValue) {
                this.value = newValue;
                
                // Calculate new cursor position
                let newCursorPos = oldCursorPos;
                
                // If we just added the colon and cursor was at position 2, move it to 3
                if (newValue.length === 3 && oldValue.length === 2 && oldCursorPos === 2) {
                  newCursorPos = 3;
                }
                // If we just added a digit after the colon
                else if (newValue.includes(':') && oldCursorPos > 2) {
                  // Cursor should be at the end
                  newCursorPos = newValue.length;
                }
                // If deleting and cursor is before the colon
                else if (oldValue.length > newValue.length && oldCursorPos <= 2) {
                  newCursorPos = oldCursorPos;
                }
                // Default: keep cursor at end
                else {
                  newCursorPos = newValue.length;
                }
                
                this.setSelectionRange(newCursorPos, newCursorPos);
              }
            } catch (err) {
              console.error('[Time Format Error]', err);
            }
          });
        });
      } catch (err) {
        console.error('[Auto-suffix Setup Error]', err);
      }
      
      // Sync current selections from main form to drawer
      syncMainToDrawer();
      
      // Populate description section with model description
      const drawerDescriptionContainer = drawerCustomization?.querySelector('[data-drawer-description] [data-description-content]');
      if (drawerDescriptionContainer && drawerBody) {
        // Clone the description HTML from drawerBody
        drawerDescriptionContainer.innerHTML = drawerBody.innerHTML;
      }

      // Attach toggle handler for description
      const descriptionToggle = drawerCustomization?.querySelector('[data-drawer-description] [data-description-toggle]');
      const descriptionContent = drawerCustomization?.querySelector('[data-drawer-description] [data-description-content]');
      const descriptionBackTop = drawerCustomization?.querySelector('[data-description-back-top]');
      const drawerScrollContainers = getDrawerScrollContainers();
      const primaryScrollSource = drawerCustomization instanceof HTMLElement ? drawerCustomization : drawerScrollContainers[0] || null;

      // Reset description state on every populate to prevent stale expanded state
      if (descriptionContent) {
        descriptionContent.setAttribute('hidden', '');
      }
      if (descriptionToggle) {
        descriptionToggle.setAttribute('aria-expanded', 'false');
      }
      if (descriptionBackTop) {
        descriptionBackTop.setAttribute('hidden', '');
      }
      let isDescriptionExpanded = false;

      const updateDescriptionBackTopVisibility = () => {
        if (!descriptionBackTop) return;
        const scrollAmount = primaryScrollSource?.scrollTop || 0;
        const shouldShow = isDescriptionExpanded && scrollAmount > 60;
        descriptionBackTop.toggleAttribute('hidden', !shouldShow);
      };

      if (descriptionToggle && descriptionContent) {
        // Remove any existing listeners by cloning the button
        const newToggle = descriptionToggle.cloneNode(true);
        descriptionToggle.parentNode?.replaceChild(newToggle, descriptionToggle);
        
        newToggle.addEventListener('click', () => {
          const isExpanded = newToggle.getAttribute('aria-expanded') === 'true';
          const nextExpandedState = !isExpanded;
          newToggle.setAttribute('aria-expanded', String(nextExpandedState));
          descriptionContent.toggleAttribute('hidden', !nextExpandedState);
          isDescriptionExpanded = nextExpandedState;
          updateDescriptionBackTopVisibility();

          if (nextExpandedState) {
            requestAnimationFrame(() => {
              descriptionContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        });
      }

      if (descriptionBackTop) {
        descriptionBackTop.addEventListener('click', () => {
          scrollDrawerToTop('smooth');
        });

        primaryScrollSource?.addEventListener('scroll', () => {
          updateDescriptionBackTopVisibility();
        });
      }
    };
    
    // Update drawer image with live preview (preserves overlay structure)
    const updateDrawerPreview = () => {
      if (!drawerImage) return;
      
      const currentModel = previewCanvas.dataset.currentModel;
      const currentColor = previewCanvas.dataset.currentColor;
      const model = findModel(currentModel);
      const color = findColor(currentColor);
      
      if (model && color) {
        const imageUrl = model.images[currentColor] || model.images['beige'];
        
        // CRITICAL FIX: Don't use innerHTML - it destroys the preview overlay structure
        // Instead, find or create the preview frame and update only the image
        let previewFrame = drawerImage.querySelector('[data-drawer-preview-frame]');
        let previewImg = drawerImage.querySelector('[data-drawer-preview-image]');
        
        if (!previewFrame) {
          // Preview frame doesn't exist - create the complete structure
          console.log('[Update Preview] Creating preview frame structure');
          drawerImage.innerHTML = `
            <div class="drawer-preview-frame" data-drawer-preview-frame>
              <img src="${imageUrl}" alt="${model.title} - ${color.label}" data-drawer-preview-image loading="lazy">
              <div class="drawer-preview-overlay" data-drawer-preview-overlay>
                <span class="drawer-preview-name" data-drawer-preview-name hidden></span>
                <div class="drawer-preview-stats" data-drawer-preview-extra hidden>
                  <span class="drawer-preview-stat drawer-preview-stat--weight" data-drawer-preview-weight hidden></span>
                  <span class="drawer-preview-stat drawer-preview-stat--height" data-drawer-preview-height hidden></span>
                  <span class="drawer-preview-stat drawer-preview-stat--time" data-drawer-preview-time hidden></span>
                </div>
                <span class="drawer-preview-date" data-drawer-preview-date hidden></span>
              </div>
            </div>
          `;
        } else if (previewImg) {
          // Preview frame exists - just update the image src
          console.log('[Update Preview] Updating existing preview image');
          previewImg.src = imageUrl;
          previewImg.alt = `${model.title} - ${color.label}`;
        }
      }
    };

    const MAX_WEIGHT_KG = 9.99;

    const normalizeWeightInput = (rawValue, isDeleting = false) => {
      const safeValue = `${rawValue || ''}`.replace(',', '.');
      const hasDot = safeValue.includes('.');
      const digitsOnly = safeValue.replace(/\D/g, '');

      if (!digitsOnly.length && !hasDot) {
        return { value: '', display: '', numeric: null };
      }

      let formatted = '';

      if (hasDot) {
        const [rawWhole = '', rawFraction = ''] = safeValue.split('.');
        const whole = rawWhole.replace(/\D/g, '').slice(0, 1) || '0';
        const fraction = rawFraction.replace(/\D/g, '').slice(0, 2);
        if (safeValue.endsWith('.') && !fraction) {
          formatted = `${whole}.`;
        } else if (fraction) {
          formatted = `${whole}.${fraction}`;
        } else {
          formatted = whole;
        }
      } else if (digitsOnly.length === 1) {
        formatted = digitsOnly + (isDeleting ? '' : '.');
      } else {
        const fraction = digitsOnly.slice(1, 3);
        formatted = `${digitsOnly[0]}.${fraction}`;
      }

      const numericValue = parseFloat(formatted.replace(/\.$/, ''));
      if (!Number.isNaN(numericValue) && numericValue > MAX_WEIGHT_KG) {
        formatted = MAX_WEIGHT_KG.toFixed(2);
      }

      const displayValue = formatted ? `${formatted.replace(/\.$/, '')} kg` : '';
      return { value: formatted, display: displayValue, numeric: numericValue };
    };

    const normalizeHeightInput = (rawValue) => {
      const digits = `${rawValue || ''}`.replace(/\D/g, '').slice(0, 2);
      const displayValue = digits ? `${digits} cm` : '';
      return { value: digits, display: displayValue };
    };

    const attachWeightBlurHandlers = (root = section) => {
      const weightInputs = root.querySelectorAll('[data-preview-input="weight"]');
      weightInputs.forEach((input) => {
        if (input.dataset.weightBlurBound === 'true') return;
        input.dataset.weightBlurBound = 'true';
        const applySuffix = function() {
          try {
            if (!this.value) return;
            const normalized = normalizeWeightInput(this.value, true);
            if (normalized.value) {
              this.value = normalized.display;
            }
          } catch (err) {
            console.error('[Weight Suffix Error]', err);
          }
        };
        input.addEventListener('blur', applySuffix);
        input.addEventListener('focusout', applySuffix);
        input.addEventListener('change', applySuffix);
      });
    };

    const attachHeightBlurHandlers = (root = section) => {
      const heightInputs = root.querySelectorAll('[data-preview-input="height"]');
      heightInputs.forEach((input) => {
        if (input.dataset.heightBlurBound === 'true') return;
        input.dataset.heightBlurBound = 'true';
        const applySuffix = function() {
          try {
            if (!this.value) return;
            const normalized = normalizeHeightInput(this.value);
            if (normalized.value) {
              this.value = normalized.display;
            }
          } catch (err) {
            console.error('[Height Suffix Error]', err);
          }
        };
        input.addEventListener('blur', applySuffix);
        input.addEventListener('focusout', applySuffix);
        input.addEventListener('change', applySuffix);
      });
    };

    const setupWeightInputDelegates = () => {
      if (section.dataset.weightDelegateBound === 'true') return;
      section.dataset.weightDelegateBound = 'true';

      section.addEventListener(
        'focusin',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (target.dataset.previewInput !== 'weight') return;
          if (!target.value) return;
          const normalized = normalizeWeightInput(target.value, true);
          if (normalized.value) {
            target.value = normalized.value;
          }
        },
        true
      );

      section.addEventListener(
        'focusout',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (target.dataset.previewInput !== 'weight') return;
          if (!target.value) return;
          const normalized = normalizeWeightInput(target.value, true);
          if (normalized.value) {
            target.value = normalized.display;
          }
        },
        true
      );
    };

    const setupHeightInputDelegates = () => {
      if (section.dataset.heightDelegateBound === 'true') return;
      section.dataset.heightDelegateBound = 'true';

      section.addEventListener(
        'focusin',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (target.dataset.previewInput !== 'height') return;
          if (!target.value) return;
          const normalized = normalizeHeightInput(target.value);
          if (normalized.value) {
            target.value = normalized.value;
          }
        },
        true
      );

      section.addEventListener(
        'focusout',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (target.dataset.previewInput !== 'height') return;
          if (!target.value) return;
          const normalized = normalizeHeightInput(target.value);
          if (normalized.value) {
            target.value = normalized.display;
          }
        },
        true
      );
    };
    
    // Handle material change in drawer
    const handleDrawerMaterialChange = (event) => {
      const materialValue = event.target.value;
      if (!materialValue) return;
      
      // Sync to main form
      const mainMaterialInput = form?.querySelector(`input[name="properties[Материя]"][value="${materialValue}"]`);
      if (mainMaterialInput && !mainMaterialInput.hasAttribute('data-drawer-input')) {
        mainMaterialInput.checked = true;
        mainMaterialInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    
    // Handle personalization input in drawer
    const handleDrawerPersonalizationInput = (event) => {
      const drawerInput = event.target;
      
      console.log('[Drawer Input] Event fired for input:', drawerInput.name, '=', drawerInput.value);
      
      // CRITICAL FIX: Update navigation buttons to reflect validation state in real-time
      updateNavigationButtons();
      
      const inputName = drawerInput.name;
      let inputValue = drawerInput.value;
      
      console.log('[Input Sync] Drawer input changed:', inputName, '=', inputValue);
      
      // Check if this is a date input field
      const isDateInput = drawerInput.hasAttribute('data-preview-input') &&
                          drawerInput.getAttribute('data-preview-input') === 'date';
      
      // Check if this is the name input field
      const isNameInput = drawerInput.hasAttribute('data-preview-input') &&
                          drawerInput.getAttribute('data-preview-input') === 'name';
      
      // Check if this is the time input field
      const isTimeInput = drawerInput.hasAttribute('data-preview-input') &&
                          drawerInput.getAttribute('data-preview-input') === 'time';

      const isWeightInput = drawerInput.hasAttribute('data-preview-input') &&
              drawerInput.getAttribute('data-preview-input') === 'weight';

      const isHeightInput = drawerInput.hasAttribute('data-preview-input') &&
              drawerInput.getAttribute('data-preview-input') === 'height';
      
      // Format date input in real-time
      if (isDateInput) {
        const isDeleting = event.inputType === 'deleteContentBackward';
        const formatted = formatDateInput(inputValue, isDeleting);
        
        // Update drawer input display value
        drawerInput.value = formatted;
        inputValue = formatted;
        
        console.log('[Input Sync] Date formatted:', inputValue, '→', formatted);
      }
      
      // Format time input in real-time with validation
      if (isTimeInput) {
        const isDeleting = event.inputType === 'deleteContentBackward';
        const timePeriodInput = section.querySelector('[data-preview-time-period]');
        const isAmPm = !!timePeriodInput?.value;
        const formatted = formatTimeInput(inputValue, isAmPm, isDeleting);
        
        // Update drawer input display value
        drawerInput.value = formatted;
        inputValue = formatted;
        
        console.log('[Input Sync] Time formatted:', inputValue, '→', formatted, 'AM/PM:', isAmPm);
      }

      if (isWeightInput) {
        const isDeleting = event.inputType === 'deleteContentBackward';
        const normalized = normalizeWeightInput(inputValue, isDeleting);
        drawerInput.value = normalized.value;
        inputValue = normalized.value;
        console.log('[Input Sync] Weight formatted:', inputValue, '→', normalized.value);
      }

      if (isHeightInput) {
        const value = inputValue.replace(/[^0-9]/g, '').slice(0, 2);
        drawerInput.value = value;
        inputValue = value;
        console.log('[Input Sync] Height formatted:', inputValue);
      }
      
      // Hybrid warning logic for Latin-only models (Option C)
      if (isNameInput) {
        const currentModel = previewCanvas?.dataset.currentModel;
        const isLatinOnlyModel = isStarModelHandle(currentModel);
        const drawerWarning = section.querySelector('[data-drawer-warning]');
        
        if (drawerWarning && isLatinOnlyModel) {
          // Check if input contains non-Latin characters (Cyrillic, etc.)
          const hasNonLatin = /[^\x00-\x7F]/.test(inputValue);
          
          // Hybrid behavior:
          // - Show if input is empty (initial state - proactive warning)
          // - Show if input has non-Latin characters (reactive warning)
          // - Hide if input has only Latin characters (positive feedback)
          const shouldShowWarning = inputValue.trim() === '' || hasNonLatin;
          drawerWarning.hidden = !shouldShowWarning;
          
          console.log('[Latin Warning] Model:', currentModel, 'Input:', inputValue, 'Has non-Latin:', hasNonLatin, 'Show warning:', shouldShowWarning);
        }
      }
      
      // Sync to main form
      const mainInput = form?.querySelector(`input[name="${inputName}"]:not([data-drawer-input]), textarea[name="${inputName}"]:not([data-drawer-input])`);
      if (mainInput) {
        mainInput.value = inputValue;
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
        console.log('[Input Sync] Synced to main form');
      } else {
        console.log('[Input Sync] Main form input not found for:', inputName);
      }

      // Update drawer preview only after values are sanitized and synced
      if (window.innerWidth <= 768) {
        console.log('[Drawer Input] Calling updateDrawerPreviewText');
        updateDrawerPreviewText();
      } else {
        console.log('[Drawer Input] Not mobile, skipping drawer preview update');
      }
    };
    
    // Sync selections from main form to drawer inputs
    const syncMainToDrawer = () => {
      if (!drawerMaterialContainer) return;
      
      // Sync material selection
      const selectedMaterial = form?.querySelector('input[name="properties[Материя]"]:checked:not([data-drawer-input])');
      if (selectedMaterial) {
        const materialValue = selectedMaterial.value;
        const drawerMaterialInput = drawerMaterialContainer.querySelector(`input[value="${materialValue}"]`);
        if (drawerMaterialInput) {
          drawerMaterialInput.checked = true;
        }
      }
      
      const syncField = (inputName, isMaterial = false) => {
        const mainInput = form?.querySelector(`input[name="${inputName}"]:not([data-drawer-input]), textarea[name="${inputName}"]:not([data-drawer-input])`);
        const drawerInput = drawerCustomization?.querySelector(`[data-drawer-customization] input[name="${inputName}"][data-drawer-input], [data-drawer-customization] textarea[name="${inputName}"][data-drawer-input]`);
        if (mainInput && drawerInput) {
          drawerInput.value = mainInput.value;
        }
      };

      syncField('properties[Име]');
      syncField('properties[Дата на раждане]');
      if (isPlanetModel) {
        syncField('properties[Тегло]');
        syncField('properties[Ръст]');
        syncField('properties[Час на раждане]');
      }
      syncField('properties[Материя]', true);
      syncField('properties[Коментар]');
    };
    
    // Toggle accordion section
    const toggleAccordion = (sectionId) => {
      const toggle = drawerCustomization?.querySelector(`[data-accordion-toggle="${sectionId}"]`);
      const content = drawerCustomization?.querySelector(`[data-accordion-content="${sectionId}"]`);
      
      if (!toggle || !content) return;
      
      const isExpanded = expandedSections.has(sectionId);
      
      if (isExpanded) {
        // Collapse
        expandedSections.delete(sectionId);
        toggle.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', '');
      } else {
        // Expand
        expandedSections.add(sectionId);
        toggle.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');
      }
    };
    
    // Attach accordion toggle handlers
    accordionToggles?.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const sectionId = toggle.dataset.accordionToggle;
        if (sectionId) {
          toggleAccordion(sectionId);
        }
      });
    });

    let currentStep = 1;
    if (section) {
      section.setAttribute('data-active-step', String(currentStep));
    }
    let previewTimeValue = '';
    let currentLayoutNameFontScale = 1;
    let step1ScrollPosition = 0;

    const OVERLAY_REFERENCE = { width: 520, height: 693 };

    const MODEL_FONTS = {
      planet: { name: "'NidoComicSans', 'Comic Sans MS', 'Comic Sans', cursive", size: 54, numbersFont: "'Arial', sans-serif", numbersSize: 14 },
      sun: { name: "'Century Schoolbook', 'Times New Roman', serif", size: 74, numbersFont: "'Arial', sans-serif", numbersSize: 15 },
      moon: { name: "'Times New Roman', serif", size: 68, numbersFont: "'Arial', sans-serif", numbersSize: 15 },
      star: { name: "'Curlz MT', 'Curlz MT Web', cursive", size: 68, numbersFont: "'Arial', sans-serif", numbersSize: 15 }
    };

    const LATIN_ONLY_MODELS = new Set(['star', 'zvezda', 'звезда']);

    const getModelTitle = (modelHandle) => {
      const model = findModel(modelHandle || '');
      return (model?.title || activeModelInput?.value || '').toLowerCase();
    };

    const isPlanetModelHandle = (modelHandle) => {
      const normalized = (modelHandle || '').toLowerCase();
      const title = getModelTitle(modelHandle);
      return normalized === 'planet' || title.includes('планета') || title.includes('planeta');
    };

    const isStarModelHandle = (modelHandle) => {
      const normalized = (modelHandle || '').toLowerCase();
      const title = getModelTitle(modelHandle);
      return LATIN_ONLY_MODELS.has(normalized) || title.includes('звезда') || title.includes('zvezda');
    };

    const MOBILE_LAYOUTS = {
      default: {
        'stats-bottom': 0.12,
        'date-bottom': 0.12,
        'stats-font-size': 19,
        'date-font-size': 19
      },
      planet: {
        'name-top': 0.398,
        'name-translate': -0.172,
        'name-letter-spacing': '-0.012em',
        'name-scale': '0.94',
        'name-font-scale': '1.08',
        'date-left': 0.275,
        'date-bottom': 0.125,
        'stats-bottom': 0.12,
        'weight-left': 0.46,
        'weight-bottom': 0.12,
        'height-left': 0.565,
        'height-bottom': 0.12,
        'time-left': 0.69,
        'time-bottom': 0.12,
        'stats-font-size': 18,
        'date-font-size': 18,
        'date-font-weight': 480
      },
      sun: {
        'name-top': 0.35,
        'name-translate': -0.12,
        'name-letter-spacing': '0.03em',
        'name-scale': '0.94',
        'name-font-scale': '0.9',
        'name-weight': 520,
        'name-word-spacing': '-0.02em',
        'date-bottom': 0.08,
        'date-right': 0.08,
        'date-left': 'auto',
        'date-text-align': 'right'
      },
      moon: {
        'name-top': 0.45,
        'name-translate': -0.17,
        'name-letter-spacing': '0.02em',
        'name-scale': '1',
        'name-font-scale': '1.05',
        'name-weight': 500,
        'name-word-spacing': '-0.015em',
        'date-bottom': 0.04,
        'date-right': 0.22,
        'date-left': 'auto',
        'date-text-align': 'right'
      },
      star: {
        'name-font-scale': '1.08',
        'date-top': 0.67
      }
    };

    const compactViewportQuery = window.matchMedia('(max-width: 720px)');
    let isCompactLayout = compactViewportQuery.matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const collectLayoutTokens = (...collections) => {
      const tokens = new Set();
      collections.forEach((collection) => {
        Object.values(collection || {}).forEach((layout) => {
          Object.keys(layout || {}).forEach((token) => tokens.add(token));
        });
      });
      return tokens;
    };

    const MODEL_LAYOUTS = {
      default: {
        'name-top': 0.4,
        'name-translate': -0.14,
        'name-letter-spacing': '0.02em',
        'name-scale': '1',
        'name-font-scale': '1',
        'name-weight': 700,
        'name-word-spacing': 0,
        'date-bottom': 0.06,
        'date-right': 0.07,
        'date-left': 'auto',
        'date-text-align': 'right',
        'date-font-size': 18,
        'stats-bottom': 0.06,
        'stats-font-size': 18,
        'weight-left': 0.12,
        'weight-bottom': 0.06,
        'height-left': 0.42,
        'height-bottom': 0.06,
        'time-left': 0.72,
        'time-bottom': 0.06,
        'date-font-weight': 480
      },
      planet: {
        'name-top': 0.402,
        'name-translate': -0.21,
        'name-letter-spacing': '-0.005em',
        'name-scale': '0.965',
        'name-font-scale': '1',
        'name-weight': 700,
        'name-word-spacing': 0,
        'date-bottom': 0.12,
        'date-right': 'auto',
        'date-left': 0.25,
        'date-text-align': 'left',
        'date-font-size': 18,
        'stats-bottom': 0.12,
        'stats-font-size': 18,
        'weight-left': 0.45,
        'weight-bottom': 0.12,
        'height-left': 0.56,
        'height-bottom': 0.12,
        'time-left': 0.69,
        'time-bottom': 0.12
      },
      moon: {
        'name-top': 0.448,
        'name-translate': -0.17,
        'name-letter-spacing': '0.018em',
        'name-scale': '0.97',
        'name-font-scale': '0.98',
        'name-weight': 480,
        'name-word-spacing': '-0.01em',
        'date-bottom': 0.04,
        'date-right': 'auto',
        'date-left': 0.65,
        'date-text-align': 'left'
      },
      sun: {
        'name-top': 0.435,
        'name-translate': -0.19,
        'name-letter-spacing': '0.021em',
        'name-scale': '1',
        'name-font-scale': '1',
        'name-weight': 520,
        'name-word-spacing': '-0.035em',
        'date-bottom': 0.05,
        'date-right': 0.212,
        'date-left': 'auto',
        'date-text-align': 'right'
      },
      star: {
        'name-top': 0.54,
        'name-translate': -0.16,
        'name-letter-spacing': '0.015em',
        'name-scale': '0.96',
        'name-font-scale': '0.97',
        'name-weight': 460,
        'name-word-spacing': '-0.012em',
        'date-bottom': null,
        'date-top': 0.64,
        'date-left': 0.5,
        'date-right': 'auto',
        'date-translate': -0.5,
        'date-text-align': 'center'
      }
    };

    const ALL_LAYOUT_TOKENS = collectLayoutTokens(MODEL_LAYOUTS, MOBILE_LAYOUTS);

    const findModel = (handle) => modelData.find((model) => model.handle === handle);

    let currentBaseNameSize = (MODEL_FONTS[config.defaultModel] || MODEL_FONTS['planet']).size;

    const findColor = (handle) => colorData.find((color) => color.handle === handle);

    const updateAccentColor = (colorHandle) => {
      const accent = findColor(colorHandle)?.accent || '#a47a43';
      previewCanvas.style.setProperty('--preview-accent', accent);
    };

    const getToggleGroup = (button) => button?.dataset.toggleGroup || 'default';

    const setGroupOpenState = (group, targetButton = null, shouldOpen = false) => {
      if (!group) return;
      descriptionToggles.forEach((btn) => {
        if (getToggleGroup(btn) !== group) return;
        const openState = targetButton ? btn === targetButton && shouldOpen : false;
        updateDescriptionToggleState(btn, openState);
      });
    };

    const collapseGroupDescriptions = (group) => setGroupOpenState(group, null, false);

    const updateTimePeriodButtons = (value = '') => {
      if (!timePeriodButtons?.length) return;
      timePeriodButtons.forEach((button) => {
        const buttonValue = button.dataset.timePeriodOption || '';
        button.classList.toggle('is-active', buttonValue === value);
      });
    };

    const toggleExtraFields = (show) => {
      if (!previewExtraFields) return;
      previewExtraFields.toggleAttribute('hidden', !show);
      extraInputs.forEach((field) => {
        field.disabled = !show;
        if (!show) {
          if (field.tagName === 'SELECT') {
            field.selectedIndex = 0;
          } else {
            field.value = '';
          }
          if (field === timePeriodSelect) {
            timePeriodSelect.dataset.previousPeriod = '';
            updateTimePeriodButtons('');
          }
        }
      });
      if (!show) {
        previewWeight.textContent = '';
        previewWeight.setAttribute('hidden', '');
        previewHeight.textContent = '';
        previewHeight.setAttribute('hidden', '');
        previewTimeValue = '';
        renderTimePreview();
      }
      refreshStatsVisibility();
    };

    const refreshStatsVisibility = () => {
      if (!previewStats) return;
      const isPlanet = isPlanetModelHandle(previewCanvas.dataset.currentModel);
      if (!isPlanet) {
        previewStats.setAttribute('hidden', '');
        return;
      }
      const hasStat = [previewWeight, previewHeight, previewTime]
        .some((node) => node && !node.hasAttribute('hidden'));
      previewStats.toggleAttribute('hidden', !hasStat);
    };

    const updateLatinOnlyWarning = (modelHandle = previewCanvas?.dataset.currentModel) => {
      const shouldShow = isStarModelHandle(modelHandle);
      
      console.log('[Latin Warning] Model:', modelHandle, 'Show warning:', shouldShow);
      
      // Update main form warning (in Step 3)
      const mainWarning = section.querySelector('[data-name-font-warning]:not([data-drawer-warning])');
      if (mainWarning) {
        mainWarning.hidden = !shouldShow;
        console.log('[Latin Warning] Main form warning updated');
      }
      
      // Update drawer warning (in mobile drawer Step 2)
      const drawerWarning = section.querySelector('[data-drawer-warning]');
      if (drawerWarning) {
        drawerWarning.hidden = !shouldShow;
        console.log('[Latin Warning] Drawer warning updated');
      }
      
      // Update desktop warning
      if (nameFontWarning) {
        nameFontWarning.hidden = !shouldShow;
      }
      
      // Update drawer warning (mobile) - query dynamically
      if (modelDrawer) {
        const drawerWarning = modelDrawer.querySelector('[data-drawer-warning]');
        if (drawerWarning) {
          drawerWarning.hidden = !shouldShow;
        }
      }
    };

    const updateDescriptionToggleState = (button, isOpen) => {
      if (!button) return;
      const targetId = button.getAttribute('aria-controls');
      const content = targetId ? document.getElementById(targetId) : null;
      button.classList.toggle('is-open', isOpen);
      button.setAttribute('aria-expanded', String(isOpen));
      const labelSpan = button.querySelector('[data-toggle-open]');
      if (labelSpan) {
        labelSpan.textContent = isOpen ? i18n.hideDescription : i18n.showDescription;
      }
      const iconSpan = button.querySelector('.toggle-icon');
      if (iconSpan) {
        iconSpan.classList.toggle('fa-angle-down', !isOpen);
        iconSpan.classList.toggle('fa-angle-up', isOpen);
      }
      if (content) {
        content.toggleAttribute('hidden', !isOpen);
      }
    };

    const collapseAllDescriptions = () => {
      descriptionToggles.forEach((btn) => updateDescriptionToggleState(btn, false));
    };

    const openDescriptionForInput = (input) => {
      if (!input) return;
      const label = input.closest('.preview-option');
      if (!label) return;
      const button = label.querySelector('[data-description-toggle]');
      if (!button) {
        const fallbackGroup = label.classList.contains('preview-option--material')
          ? 'material'
          : label.classList.contains('preview-option--model')
            ? 'model'
            : null;
        if (fallbackGroup) {
          collapseGroupDescriptions(fallbackGroup);
        } else {
          collapseAllDescriptions();
        }
        return;
      }
      const group = getToggleGroup(button);
      setGroupOpenState(group, button, true);
    };

    descriptionToggles.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const card = button.closest('.preview-option');
        const optionInput = card?.querySelector('input[type="radio"]');
        if (optionInput && !optionInput.checked) {
          optionInput.checked = true;
          optionInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const group = getToggleGroup(button);
        const willOpen = !button.classList.contains('is-open');
        setGroupOpenState(group, button, willOpen);
      });
    });

    const previewOverlay = section.querySelector('[data-preview-overlay]');
    const attachBlanketInfoToggle = (block) => {
      if (!block) return;
      const toggle = block.querySelector('[data-blanket-info-toggle]');
      const content = block.querySelector('[data-blanket-info-content]');
      if (!toggle || !content) return;
      toggle.addEventListener('click', () => {
        const willOpen = content.hasAttribute('hidden');
        toggle.setAttribute('aria-expanded', String(willOpen));
        content.toggleAttribute('hidden', !willOpen);
        block.classList.toggle('is-open', willOpen);
      });
    };

    const getOverlayScale = () => {
      if (!previewCanvas) return 1;
      const computed = parseFloat(getComputedStyle(previewCanvas).getPropertyValue('--overlay-scale'));
      return Number.isFinite(computed) ? computed : 1;
    };

    const updateOverlayScale = () => {
      if (!previewCanvas || !previewOverlay) return;
      const referenceWidth = 520;
      const width = previewOverlay.clientWidth || referenceWidth;
      const scale = width / referenceWidth;
      const normalizedScale = Number.isFinite(scale) && scale > 0 ? scale : 1;
      previewCanvas.style.setProperty('--overlay-scale', normalizedScale.toFixed(3));
    };

    const WIDTH_BASED_TOKENS = new Set(['date-left', 'date-right', 'weight-left', 'height-left', 'time-left']);
    const HEIGHT_BASED_TOKENS = new Set(['name-top', 'date-bottom', 'date-top', 'stats-bottom', 'weight-bottom', 'height-bottom', 'time-bottom']);
    const PERCENT_TOKENS = new Set(['name-translate', 'date-translate']);
    const FONT_SIZE_TOKENS = new Set(['date-font-size', 'stats-font-size']);

    const getScaledTokenValue = (token, value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed.endsWith('px')) {
          return trimmed;
        }
        if (isNaN(parseFloat(trimmed))) {
          return value;
        }
      }
      const overlayWidth = previewOverlay?.clientWidth || OVERLAY_REFERENCE.width;
      const overlayHeight = previewOverlay?.clientHeight || OVERLAY_REFERENCE.height;
      const scaleX = overlayWidth / OVERLAY_REFERENCE.width;
      const scaleY = overlayHeight / OVERLAY_REFERENCE.height;

      if (WIDTH_BASED_TOKENS.has(token)) {
        return `${(Number(value) * OVERLAY_REFERENCE.width * scaleX).toFixed(2)}px`;
      }
      if (HEIGHT_BASED_TOKENS.has(token)) {
        return `${(Number(value) * OVERLAY_REFERENCE.height * scaleY).toFixed(2)}px`;
      }
      if (PERCENT_TOKENS.has(token)) {
        return `${(Number(value) * 100).toFixed(3)}%`;
      }
      if (FONT_SIZE_TOKENS.has(token)) {
        return `${(Number(value) * scaleY).toFixed(2)}px`;
      }
      return value;
    };

    const applyLayoutVariables = (handle) => {
      if (!previewCanvas) return;
      const base = MODEL_LAYOUTS.default || {};
      const overrides = MODEL_LAYOUTS[handle] || {};
      const compactBase = isCompactLayout ? (MOBILE_LAYOUTS.default || {}) : {};
      const compactOverrides = isCompactLayout ? (MOBILE_LAYOUTS[handle] || {}) : {};
      const layout = { ...base, ...overrides, ...compactBase, ...compactOverrides };
      ALL_LAYOUT_TOKENS.forEach((token) => {
        if (!Object.prototype.hasOwnProperty.call(layout, token) || layout[token] === null || layout[token] === undefined) {
          previewCanvas.style.removeProperty(`--layout-${token}`);
          return;
        }
        const resolved = getScaledTokenValue(token, layout[token]);
        if (resolved === null) {
          previewCanvas.style.removeProperty(`--layout-${token}`);
        } else {
          previewCanvas.style.setProperty(`--layout-${token}`, resolved);
        }
      });
      currentLayoutNameFontScale = parseFloat(layout['name-font-scale']) || 1;
    };

    const updateFoldedPreviewVisibility = () => {
      if (!foldedPreview) return;
      const shouldHide = isCompactLayout && currentStep === 3;
      foldedPreview.classList.toggle('is-mobile-hidden', shouldHide);
    };

    const scrollToPreviewTop = () => {
      if (!section) return;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;

      if (!isCompactLayout && window.scrollY <= sectionTop + 24) {
        return;
      }

      const targetTop = Math.max(sectionTop - 8, 0);
      window.scrollTo({ top: targetTop, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      requestAnimationFrame(() => updateScrollButtonState());
    };

    const getActiveScrollHost = () => {
      const windowOffset = window.scrollY || window.pageYOffset || 0;
      if (windowOffset > 0 || scrollHost === window) return window;
      if (scrollHost && scrollHost !== window && (scrollHost.scrollTop || 0) > 0) return scrollHost;
      return scrollHost || window;
    };

    const getScrollOffset = () => {
      const host = getActiveScrollHost();
      if (host !== window) {
        return host.scrollTop || 0;
      }
      return window.scrollY || window.pageYOffset || 0;
    };

    const getElementTopInScrollHost = (element) => {
      if (!element) return 0;
      const host = getActiveScrollHost();
      const rect = element.getBoundingClientRect();
      if (host !== window) {
        const hostRect = host.getBoundingClientRect();
        return rect.top - hostRect.top + getScrollOffset();
      }
      return rect.top + getScrollOffset();
    };

    const scrollHostTo = (top) => {
      const host = getActiveScrollHost();
      const behavior = prefersReducedMotion ? 'auto' : 'smooth';
      if (host !== window && typeof host.scrollTo === 'function') {
        host.scrollTo({ top, behavior });
      } else if (host !== window) {
        host.scrollTop = top;
      } else {
        window.scrollTo({ top, behavior });
      }
      requestAnimationFrame(() => updateScrollButtonState());
    };

    const scrollToPageTop = () => {
      scrollHostTo(0);
    };

    const scrollToFormTop = () => {
      if (!formAnchor) return;
      const anchorTop = getElementTopInScrollHost(formAnchor);
      const targetTop = Math.max(anchorTop - 8, 0);
      scrollHostTo(targetTop);
    };

    const scrollToViewportTop = () => {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
      requestAnimationFrame(() => updateScrollButtonState());
    };
    const scrollToStepTop = (stepIndex) => {
      if (!stepNodes || !stepNodes.length) {
        scrollToFormTop();
        return;
      }
      const targetStep = Array.from(stepNodes).find((step) => {
        const stepNumber = parseInt(step.getAttribute('data-step'), 10);
        return stepNumber === stepIndex;
      });
      if (!targetStep) {
        scrollToFormTop();
        return;
      }
      const stepTop = getElementTopInScrollHost(targetStep);
      const targetTop = Math.max(stepTop - 8, 0);
      scrollHostTo(targetTop);
    };

    const scrollToColorFilterTop = () => {
      const colorFilter = section?.querySelector('.preview-color-filter');
      if (!colorFilter) {
        scrollToFormTop();
        return;
      }
      const label = colorFilter.querySelector('h4');
      const targetElement = label || colorFilter;
      const elementTop = getElementTopInScrollHost(targetElement);
      const targetTop = Math.max(elementTop - 80, 0);
      scrollHostTo(targetTop);
    };

    const isNearSectionTop = () => {
      if (!section) return true;
      const sectionTop = getElementTopInScrollHost(section);
      return getScrollOffset() <= sectionTop + 24;
    };

    const updateScrollButtonState = () => {
      if (!scrollToggleButton) return;
      const shouldShow = isCompactLayout;
      scrollToggleButton.classList.toggle('is-visible', shouldShow);
      if (!shouldShow) return;
      const isAtTop = isNearSectionTop();
      scrollToggleButton.classList.toggle('is-reverse', isAtTop);
      if (scrollButtonIcon) {
        scrollButtonIcon.classList.toggle('fa-arrow-down', isAtTop);
        scrollButtonIcon.classList.toggle('fa-arrow-up', !isAtTop);
      }
    };

    const handleViewportLayoutChange = (event) => {
      isCompactLayout = event.matches;
      applyLayoutVariables(previewCanvas.dataset.currentModel);
      updateNameSize();
      updateFoldedPreviewVisibility();
      updateScrollButtonState();
    };

    if (compactViewportQuery.addEventListener) {
      compactViewportQuery.addEventListener('change', handleViewportLayoutChange);
    } else if (compactViewportQuery.addListener) {
      compactViewportQuery.addListener(handleViewportLayoutChange);
    }

    const updatePreviewFonts = (handle) => {
      const fontConfig = MODEL_FONTS[handle] || MODEL_FONTS['planet'];
      previewName.style.fontFamily = fontConfig.name;
      previewDate.style.fontFamily = fontConfig.numbersFont;
      previewStats.style.fontFamily = fontConfig.numbersFont;
      section.style.setProperty('--preview-name-placeholder-font', fontConfig.name);
      currentBaseNameSize = fontConfig.size;
      updateNameSize();
      
      // Apply decorative font to all name input fields
      const nameInputs = form?.querySelectorAll('[data-preview-input="name"]');
      nameInputs?.forEach(input => {
        input.style.fontFamily = fontConfig.name;
      });
      
      // Apply decorative font to drawer name inputs if present
      const drawer = document.querySelector('[data-model-drawer]');
      const drawerNameInputs = drawer?.querySelectorAll('[data-preview-input="name"]');
      drawerNameInputs?.forEach(input => {
        input.style.fontFamily = fontConfig.name;
      });
    };

    const updateNameSize = () => {
      if (!previewName) return;
      const length = (previewName.textContent || '').trim().length;
      const adjusted = length > 8 ? Math.max(currentBaseNameSize - (length - 8) * 3, 32) : currentBaseNameSize;
      const scale = getOverlayScale();
      previewName.style.fontSize = adjusted * scale * currentLayoutNameFontScale + 'px';
    };

    const overlayResizeHandler = () => {
      updateOverlayScale();
      applyLayoutVariables(previewCanvas.dataset.currentModel);
      updateNameSize();
    };

    if (typeof ResizeObserver !== 'undefined' && previewCanvas) {
      const overlayObserver = new ResizeObserver(overlayResizeHandler);
      overlayObserver.observe(previewCanvas);
    } else {
      window.addEventListener('resize', overlayResizeHandler);
    }

    const renderTimePreview = () => {
      const suffix = timePeriodSelect?.value || '';
      const normalized = suffix ? normalizeTimeValue(previewTimeValue) : previewTimeValue;
      const base = normalized || previewTimeValue;
      const display = base ? `${base}${suffix ? ` ${suffix}` : ''}` : '';
      previewTime.textContent = display;
      previewTime.toggleAttribute('hidden', !display);
      if (previewTime) {
        const is24h = !suffix;
        if (isCompactLayout && is24h) {
          previewTime.style.setProperty('--stat-shift', '-7px');
        } else {
          previewTime.style.removeProperty('--stat-shift');
        }
      }
      refreshStatsVisibility();
    };

    const updatePreviewImage = (modelHandle, colorHandle) => {
      const model = findModel(modelHandle);
      if (!model) return;
      const displayImageUrl = model.images[colorHandle] || model.images['beige'];
      if (displayImageUrl) {
        previewImage.src = displayImageUrl;
      }
      if (foldedPreviewImage) {
        const foldedImages = model.folded_images || {};
        const foldedUrl = foldedImages[colorHandle] || foldedImages['beige'] || '';
        const canShowFolded = !!foldedUrl && currentStep >= 2;
        if (canShowFolded) {
          foldedPreviewImage.src = foldedUrl;
          const colorLabel = findColor(colorHandle)?.label || '';
          foldedPreviewImage.alt = `${model.title}${colorLabel ? ` - ${colorLabel}` : ''} (${i18n.foldedBlanket})`;
          foldedPreview?.removeAttribute('hidden');
          if (previewImageInput) {
            previewImageInput.value = foldedUrl;
          }
        } else {
          foldedPreview?.setAttribute('hidden', '');
          if (previewImageInput && displayImageUrl) {
            previewImageInput.value = displayImageUrl;
          }
        }
      }
      if (foldedPreviewMeta) {
        const colorLabel = findColor(colorHandle)?.label;
        const parts = [model.title, colorLabel].filter(Boolean);
        foldedPreviewMeta.textContent = parts.join(' — ');
      }
      previewCanvas.dataset.currentModel = modelHandle;
      previewCanvas.dataset.currentColor = colorHandle;
      applyLayoutVariables(modelHandle);
      updateAccentColor(colorHandle);
      const requiresExtra = isPlanetModelHandle(modelHandle);
      toggleExtraFields(requiresExtra);
      refreshStatsVisibility();
      updateLatinOnlyWarning(modelHandle);
    };

    const showStep = (index) => {
      currentStep = index;
      stepNodes.forEach((step) => {
        const stepIndex = parseInt(step.getAttribute('data-step'), 10);
        if (stepIndex === index) {
          step.setAttribute('data-step-active', '');
        } else {
          step.removeAttribute('data-step-active');
        }
      });
      progressSteps.forEach((button) => {
        const stepIndex = parseInt(button.dataset.progressStep, 10);
        button.classList.toggle('is-active', stepIndex === index);
        button.classList.toggle('is-complete', stepIndex < index);
      });

      // Update panel with current step for styling
      const panel = section.querySelector('.personalization-preview__panel');
      if (panel) {
        panel.setAttribute('data-current-step', index);
      }
      section.setAttribute('data-active-step', String(index));

      // Hide hero header on Step 1 only
      heroHeader?.toggleAttribute('hidden', index === 1);

      // Re-apply preview state so folded image gating reflects current step
      updatePreviewImage(previewCanvas.dataset.currentModel, previewCanvas.dataset.currentColor);

      updateFoldedPreviewVisibility();
      updateScrollButtonState();
    };

    progressSteps.forEach((button) => {
      button.addEventListener('click', () => {
        const target = parseInt(button.dataset.progressStep, 10);
        showStep(target);
        scrollToFormTop();
      });
    });

    section.querySelectorAll('[data-next-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentStep < stepNodes.length) {
          // Check current step BEFORE incrementing
          const wasOnStep1 = currentStep === 1;
          
          // On mobile Step 1, open drawer instead of going to Step 2
          if (wasOnStep1 && window.innerWidth <= 768) {
            showDrawerCustomization();
            return;
          }
          
          // Capture Step 1 scroll position before leaving
          if (wasOnStep1) {
            step1ScrollPosition = window.scrollY;
          }

          const nextStep = currentStep + 1;
          showStep(nextStep);
          scrollToViewportTop();
        }
      });
    });

    section.querySelectorAll('[data-prev-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentStep > 1) {
          // Check if returning to Step 1 from Step 2
          const returningToStep1 = currentStep === 2;
          
          showStep(currentStep - 1);
          
          // Restore Step 1 scroll position when coming back from Step 2
          if (returningToStep1) {
            window.scrollTo({
              top: step1ScrollPosition,
              behavior: prefersReducedMotion ? 'auto' : 'smooth'
            });
            requestAnimationFrame(() => updateScrollButtonState());
          } else {
            // Other backward navigation - scroll to form
            scrollToFormTop();
          }
        }
      });
    });

    scrollToggleButton?.addEventListener('click', () => {
      if (!isCompactLayout) return;
      if (isNearSectionTop()) {
        scrollToFormTop();
      } else {
        scrollToColorFilterTop();
      }
    });

    window.addEventListener('scroll', updateScrollButtonState, { passive: true });
    if (scrollHost && scrollHost !== window) {
      scrollHost.addEventListener('scroll', updateScrollButtonState, { passive: true });
    }

    /**
     * @param {HTMLInputElement} inputElement
     */
    const handleModelSelection = (inputElement) => {
      const handle = inputElement.dataset.modelHandle || '';
      if (!handle) return;

      activeModelInput = inputElement;
      updatePreviewFonts(handle);
      updateNameSize();
      const colorHandle = previewCanvas?.dataset.currentColor;
      if (colorHandle) {
        updatePreviewImage(handle, colorHandle);
      }
      updateLatinOnlyWarning(handle);

      // Show Step 1 Continue button when model is selected
      showStep1ContinueButton();

      // On mobile, open customization drawer after model selection
      if (window.innerWidth <= 768 && currentStep === 1) {
        setTimeout(() => {
          showDrawerCustomization();
        }, 300);
        return;
      }

      // On desktop, jump directly to Step 2 ("Избор на материя") after selecting a model
      if (window.innerWidth > 768 && currentStep === 1) {
        showStep(2);
        scrollToViewportTop();
        return;
      }

      // On Step 1, scroll to center the selected model tile
      if (currentStep === 1) {
        const modelTile = section.querySelector(`[data-model-tile="${handle}"]`);
        if (modelTile) {
          setTimeout(() => {
            const tileRect = modelTile.getBoundingClientRect();
            const absoluteTop = window.scrollY + tileRect.top;
            const tileHeight = tileRect.height;
            const viewportHeight = window.innerHeight;
            const scrollTarget = absoluteTop - (viewportHeight / 2) + (tileHeight / 2);
            window.scrollTo({
              top: Math.max(0, scrollTarget),
              behavior: prefersReducedMotion ? 'auto' : 'smooth'
            });
          }, 50);
        }
      } else {
        scrollToPreviewTop();
      }
    };

    form?.querySelectorAll('input[name="properties[Модел]"]').forEach((inputEl) => {
      if (!(inputEl instanceof HTMLInputElement)) return;

      inputEl.addEventListener('change', (event) => {
        const target = event.currentTarget instanceof HTMLInputElement ? event.currentTarget : inputEl;
        handleModelSelection(target);
      });

      inputEl.addEventListener('click', () => {
        if (currentStep !== 1) return;
        if (!inputEl.checked) return; // only trigger when already selected

        if (window.innerWidth <= 768) {
          setTimeout(() => {
            showDrawerCustomization();
          }, 150);
        } else {
          showStep(2);
          scrollToViewportTop();
        }
      });
    });

    // Color change handler - updates preview AND all model tile images
    section.querySelectorAll('input[data-color-handle]').forEach((input) => {
      input.addEventListener('change', () => {
        const colorHandle = input.dataset.colorHandle;
        const modelHandle = previewCanvas.dataset.currentModel;
        updatePreviewImage(modelHandle, colorHandle);
        updateLatinOnlyWarning(modelHandle);
        
        // Update all model tile images to show selected color
        updateModelTileColors(colorHandle);
        
        scrollToPreviewTop();
      });
    });
    
    // Update all model tile images based on selected color
    const updateModelTileColors = (colorHandle) => {
      const modelTiles = section.querySelectorAll('[data-model-tile]');
      const colorKey = colorHandle ? `${colorHandle.charAt(0).toUpperCase()}${colorHandle.slice(1)}` : '';
      modelTiles.forEach(tile => {
        const modelHandle = tile.dataset.modelTile;
        const model = findModel(modelHandle);
        if (!model) return;
        
        const overrideKey = colorKey ? `modelTileImage${colorKey}` : '';
        const overrideUrl = overrideKey ? tile.dataset[overrideKey] : '';
        const imageUrl = overrideUrl || model.images[colorHandle] || model.images['beige'];
        const imgElement = tile.querySelector('.preview-model-tile__image img');
        if (imgElement && imageUrl) {
          imgElement.src = imageUrl;
        }
      });
    };

    const isNameInputValid = () => {
      if (!nameInput) return false;
      return (nameInput.value || '').trim().length > 0;
    };

    const updateAddToCartState = () => {
      if (!addToCartButton) return;
      addToCartButton.classList.remove('is-disabled');
      addToCartButton.removeAttribute('disabled');
      addToCartButton.setAttribute('aria-disabled', 'false');
    };

    materialInputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        openDescriptionForInput(event.currentTarget);
        updateAddToCartState();
      });
    });

    form?.querySelectorAll('input[name="properties[Модел]"]').forEach((input) => {
      input.addEventListener('change', () => {
        updateAddToCartState();
      });
    });

    section.querySelectorAll('input[data-color-handle]').forEach((input) => {
      input.addEventListener('change', () => {
        updateAddToCartState();
      });
    });

    const handleNameInputUpdate = () => updateAddToCartState();
    nameInput?.addEventListener('input', handleNameInputUpdate);
    nameInput?.addEventListener('change', handleNameInputUpdate);
    nameInput?.addEventListener('blur', handleNameInputUpdate);

    // Auto-append kg suffix to weight input
    attachWeightBlurHandlers();
    setupWeightInputDelegates();

    // Auto-append cm suffix to height input
    attachHeightBlurHandlers();
    setupHeightInputDelegates();

    updateAddToCartState();

    const formatDateInput = (value, isDeleting) => {
      const digitsOnly = value.replace(/[^0-9]/g, '');
      if (!digitsOnly.length) return '';
      const clipped = digitsOnly.slice(0, 8);
      const parts = [];
      if (clipped.length <= 2) {
        const day = Math.min(parseInt(clipped, 10), 31) || parseInt(clipped, 10);
        parts.push(day?.toString().padStart(clipped.length, '0') || clipped);
      } else if (clipped.length <= 4) {
        const day = Math.min(parseInt(clipped.slice(0, 2), 10), 31) || parseInt(clipped.slice(0, 2), 10);
        const monthDigits = clipped.slice(2);
        const month = Math.min(parseInt(monthDigits, 10), 12) || parseInt(monthDigits, 10);
        parts.push(day?.toString().padStart(2, '0') || digits.slice(0, 2));
        parts.push(month?.toString().padStart(monthDigits.length, '0') || monthDigits);
      } else {
        const day = Math.min(parseInt(clipped.slice(0, 2), 10), 31) || parseInt(clipped.slice(0, 2), 10);
        const month = Math.min(parseInt(clipped.slice(2, 4), 10), 12) || parseInt(clipped.slice(2, 4), 10);
        let year = clipped.slice(4);
        if (year.length >= 2 && !year.startsWith('20')) {
          year = '20' + year.slice(2, 4);
        }
        year = year.slice(0, 4);
        parts.push(day?.toString().padStart(2, '0') || digits.slice(0, 2));
        parts.push(month?.toString().padStart(2, '0') || digits.slice(2, 4));
        parts.push(year);
      }
      let formatted = parts.filter(Boolean).join('.');
      if (isDeleting && value.endsWith('.') && formatted.length >= value.length) {
        formatted = formatted.slice(0, -1);
      }
      return formatted;
    };

    const normalizeTimeValue = (value) => {
      if (!value) return '';
      if (value.includes(':')) {
        const parts = value.split(':');
        const hoursDigits = parts[0]?.replace(/[^0-9]/g, '') || '';
        const minutesDigits = parts[1]?.replace(/[^0-9]/g, '') || '';
        if (!hoursDigits) return '';
        const normalizedHours = hoursDigits.slice(-2).padStart(2, '0');
        const normalizedMinutes = (minutesDigits || '00').slice(0, 2).padEnd(2, '0');
        return `${normalizedHours}:${normalizedMinutes}`;
      }
      const digits = value.replace(/[^0-9]/g, '');
      if (!digits) return '';
      const hours = digits.slice(0, 2).padStart(2, '0');
      const minutes = digits.slice(2, 4);
      return `${hours}:${(minutes || '00').padEnd(2, '0')}`;
    };

    const formatTimeInput = (value, isAmPm, isDeleting) => {
      if (isDeleting && value.endsWith(':')) {
        return value.slice(0, -1);
      }
      const digits = value.replace(/[^0-9]/g, '').slice(0, 4);
      if (!digits.length) return '';
      let hours = digits.slice(0, 2);
      let minutes = digits.slice(2, 4);

      if (hours) {
        let hoursNum = parseInt(hours, 10);
        if (isAmPm && hoursNum > 12) hoursNum = 12;
        if (!isAmPm && hoursNum > 23) hoursNum = 23;
        hours = hoursNum.toString().padStart(Math.min(hours.length, 2), '0');
      }

      if (digits.length <= 2) {
        return hours;
      }

      let minutesNum = parseInt(minutes || '0', 10);
      if (minutesNum > 59) minutesNum = 59;
      minutes = minutesNum.toString().padStart(Math.min(minutes.length || 2, 2), '0');

      return `${hours}:${minutes}`;
    };

    section.querySelectorAll('[data-preview-input]').forEach((input) => {
      input.addEventListener('input', (event) => {
        const isDeleting = event.inputType === 'deleteContentBackward';
        const target = input.dataset.previewInput;
        if (target === 'name') {
          const lettersOnly = input.value.replace(/[^\p{L}\s'-]/gu, '');
          const collapsed = lettersOnly.replace(/\s{2,}/g, ' ');
          let normalized = collapsed.toLowerCase();
          const firstLetterIndex = normalized.search(/[\p{L}]/u);
          if (firstLetterIndex >= 0) {
            normalized =
              normalized.slice(0, firstLetterIndex) +
              normalized.charAt(firstLetterIndex).toUpperCase() +
              normalized.slice(firstLetterIndex + 1);
          }
          if (normalized !== input.value) {
            input.value = normalized;
          }
          const displayName = normalized.trim();
          previewName.textContent = displayName;
          previewName.toggleAttribute('hidden', !displayName);
          updateNameSize();
          updateLatinOnlyWarning();
        }
        if (target === 'date') {
          const formatted = formatDateInput(input.value, isDeleting);
          input.value = formatted;
          previewDate.textContent = formatted;
          previewDate.toggleAttribute('hidden', !formatted);
        }
        if (target === 'weight') {
          const normalized = normalizeWeightInput(input.value, isDeleting);
          input.value = normalized.value;
          previewWeight.textContent = normalized.display;
          previewWeight.toggleAttribute('hidden', !normalized.display);
          refreshStatsVisibility();
        }
        if (target === 'height') {
          const value = input.value.replace(/[^0-9]/g, '').slice(0, 2);
          input.value = value;
          const heightDisplay = value ? `${value} cm` : '';
          previewHeight.textContent = heightDisplay;
          previewHeight.toggleAttribute('hidden', !heightDisplay);
          refreshStatsVisibility();
        }
        if (target === 'time') {
          const formatted = formatTimeInput(input.value, !!timePeriodSelect?.value, isDeleting);
          input.value = formatted;
          previewTimeValue = formatted;
          renderTimePreview();
        }
      });
    });

    const convertToAmPm = (timeValue, preferredPeriod = null) => {
      const normalizedValue = normalizeTimeValue(timeValue);
      if (!normalizedValue) return { time: '', period: preferredPeriod || '' };
      let [hours, minutes] = normalizedValue.split(':');
      let hNum = parseInt(hours, 10);
      if (Number.isNaN(hNum)) {
        return { time: normalizedValue, period: preferredPeriod || '' };
      }
      const period = preferredPeriod || (hNum >= 12 ? 'PM' : 'AM');
      if (period === 'AM') {
        if (hNum === 0) {
          hNum = 12;
        } else if (hNum > 12) {
          hNum -= 12;
        }
      } else {
        if (hNum === 0) {
          hNum = 12;
        } else if (hNum > 12) {
          hNum -= 12;
        }
      }
      return { time: `${hNum.toString().padStart(2, '0')}:${minutes}`, period };
    };

    const syncDrawerTimeField = (timeValue) => {
      const drawerTimeField = drawerCustomization?.querySelector('[data-drawer-time-field]');
      if (!drawerTimeField) return;
      const drawerTimeInput = drawerTimeField.querySelector('[data-drawer-input][data-preview-input="time"]');
      if (drawerTimeInput) {
        drawerTimeInput.value = timeValue || '';
      }
      const drawerPeriodInput = drawerTimeField.querySelector('[data-preview-time-period]');
      if (drawerPeriodInput) {
        drawerPeriodInput.value = timePeriodSelect?.value || '';
      }
      const drawerButtons = drawerTimeField.querySelectorAll('[data-time-period-option]');
      drawerButtons.forEach((button) => {
        const option = button.dataset.timePeriodOption || '';
        button.classList.toggle('is-active', option === (timePeriodSelect?.value || ''));
      });
    };

    const handleTimePeriodChange = () => {
      if (!timePeriodSelect) return;
      updateTimePeriodButtons(timePeriodSelect.value || '');
      const timeInput = form?.querySelector('[data-preview-input="time"]');
      const previousPeriod = timePeriodSelect.dataset.previousPeriod || '';
      const rawValue = timeInput?.value || previewTimeValue;
      const normalizedValue = normalizeTimeValue(rawValue);

      if (timePeriodSelect.value) {
        if (normalizedValue) {
          const { time } = convertToAmPm(normalizedValue, timePeriodSelect.value);
          previewTimeValue = time;
          if (timeInput) {
            timeInput.value = time;
          }
        } else {
          previewTimeValue = '';
        }
      } else if (normalizedValue) {
        const [hours, minutes] = normalizedValue.split(':');
        let hNum = parseInt(hours, 10);
        if (previousPeriod === 'PM' && hNum < 12) {
          hNum += 12;
        }
        if (previousPeriod === 'AM' && hNum === 12) {
          hNum = 0;
        }
        previewTimeValue = `${hNum.toString().padStart(2, '0')}:${minutes}`;
        if (timeInput) {
          timeInput.value = previewTimeValue;
        }
      } else {
        previewTimeValue = '';
      }

      const appliedTimeValue = timeInput?.value || previewTimeValue;
      syncDrawerTimeField(appliedTimeValue);
      timePeriodSelect.dataset.previousPeriod = timePeriodSelect.value;
      renderTimePreview();
      if (window.innerWidth <= 768) {
        updateDrawerPreviewText();
      }
    };

    const setupTimeControls = () => {
      if (!timePeriodSelect) return;

      timePeriodSelect.addEventListener('change', handleTimePeriodChange);

      timePeriodButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selectedValue = button.dataset.timePeriodOption || '';
          if (timePeriodSelect.value === selectedValue) return;
          timePeriodSelect.value = selectedValue;
          updateTimePeriodButtons(selectedValue);
          timePeriodSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      form?.addEventListener('submit', () => {
        const weightInput = form.querySelector('[data-preview-input="weight"]');
        if (weightInput?.value) {
          weightInput.value = `${weightInput.value} kg`;
        }
        const heightInput = form.querySelector('[data-preview-input="height"]');
        if (heightInput?.value) {
          heightInput.value = `${heightInput.value} cm`;
        }
        const timeInput = form.querySelector('[data-preview-input="time"]');
        if (timeInput?.value) {
          timeInput.value = `${timeInput.value}${timePeriodSelect?.value ? ` ${timePeriodSelect.value}` : ''}`;
        }
      });

      timePeriodSelect.dataset.previousPeriod = timePeriodSelect.value || '';
      updateTimePeriodButtons(timePeriodSelect.value || '');
      renderTimePreview();
    };

    blanketInfoBlocks.forEach((block) => attachBlanketInfoToggle(block));

    setupTimeControls();

      // Initialize
      showStep(1);
      updateFoldedPreviewVisibility();
      updatePreviewFonts(config.defaultModel);
      updatePreviewImage(config.defaultModel, config.defaultColor);
      previewName.toggleAttribute('hidden', true);
      previewDate.toggleAttribute('hidden', true);
      updateNameSize();
      renderTimePreview();
      updateLatinOnlyWarning(previewCanvas.dataset.currentModel);
      const defaultModelInput = form?.querySelector('input[name="properties[Модел]"]:checked');
      if (defaultModelInput) {
        activeModelInput = defaultModelInput;
      }
      const defaultMaterialInput = form?.querySelector('input[name="properties[Материя]"]:checked');
      if (defaultMaterialInput) {
        requestAnimationFrame(() => openDescriptionForInput(defaultMaterialInput));
      }
      updateAddToCartState();
    };

    const bootstrap = (root = document) => {
      const scripts = root.querySelectorAll(CONFIG_SELECTOR);
      scripts.forEach((scriptEl) => {
        const config = parseConfig(scriptEl);
        if (config) {
          initialize(config);
        }
      });
    };

    const handleSectionLoad = (event) => {
      const container = event.target || (event.detail?.sectionId && document.getElementById(`shopify-section-${event.detail.sectionId}`));
      if (container) {
        bootstrap(container);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootstrap());
    } else {
      bootstrap();
    }

    document.addEventListener('shopify:section:load', handleSectionLoad);

  })();